module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ch-title"
  }, [_vm._v("The Dialogue between Jesus and the Devil")]), _vm._v(" "), _c('p', {
    staticClass: "ch-subtitle"
  }, [_vm._v("A translation and introduction")]), _vm._v(" "), _c('p', {
    staticClass: "ch-author"
  }, [_vm._v("by Chance E. Bonar and Slavomír Čéplö")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The "), _c('em', [_vm._v("Dialogue between Jesus and the Devil")]), _vm._v(" ("), _c('em', [_vm._v("Dial. Devil")]), _vm._v("; "), _c('em', [_vm._v("CANT")]), _vm._v(" 84) is a narrative dialogue between Jesus and the devil that takes place amidst the temptation account of Matt 4:1–11 and Luke 4:1–13. In the Greek manuscripts, the text is known as the “Discourse of our Lord Jesus Christ regarding the dispute with the devil” and the “Narration of the dispute of the devil with our Lord Jesus Christ.” This apocryphal text has been given relatively little attention by scholars because of its general lack of translation into modern languages and the lack of a critical edition of all known Greek and Church Slavic manuscripts. "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" provides a glimpse into Byzantine dialogue traditions as well as the development of the character of Satan and the antichrist in the late ancient and early medieval Christian world."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-001",
      "id": "foot_001"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Greek version of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" is available in two forms. Recension A, translated here, begins with Jesus and his disciples fasting for forty days on a mountain, mirroring both the transfiguration and the temptation narratives."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-002",
      "id": "foot_002"
    }
  }, [_vm._v("2")])]), _vm._v(" Soon after their arrival, the devil appears and questions Jesus regarding his purpose on earth. Jesus explains that he came down from heaven in order to kill the devil and release humanity from his stranglehold (chap. 1). Jesus then goes on to enumerate the devil’s accomplices and the necessity of being born as a human in order to assist humanity (chap. 2). The devil questions at what age repentance is still possible for humans, and Jesus elucidates what happens to repentant and unrepentant sinners in the afterlife (chap. 3). In response to this information, the devil summons a horde of demons in order to kill Jesus, but is stopped when Jesus transfigures and suspends the devil upside down by his feet in a heavenly cloud (chaps. 4–5). Once the devil agrees to end his war against humanity, Jesus releases him and the devil declares himself the antichrist. The devil explains to Jesus his plan to convince Annas and Caiaphas to kill him, but refutes the claim that he caused John the Baptist’s death (chap. 6). The narrative ends with Jesus transfiguring a second time in order to open a fissure in the earth. Jesus goes on to tell the devil about his fate—particularly how the devil will be reborn from a woman named Perdition and will go to a place called Gouze in Egypt, where he will eventually be killed by the Virgin Mary, Elijah, and Enoch (chap. 7).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Greek recension B is missing its introduction because of a lost folio and so begins "), _c('em', [_vm._v("in medias res")]), _vm._v(" with Jesus recounting how repentant sinners will be taken by Michael and be enlightened once in paradise (chap. 1). Jesus goes on to explain how unrepentant sinners are handed over to Temeluchus and the demons for punishment in the outer darkness (chap. 2). Much like recension A, Jesus lists the accomplices of the devil—including those who stab their foster siblings with a knife—and traps the devil in a cloud (chaps. 3–4). In this recension, Jesus often responds to the devil’s questions with “O Satan, are you debating again?” Although the devil spits on Jesus while attempting to overpower him, Jesus refuses to use his healing spit or holy breath against the devil. They then debate which of them is shadow-like or less-than-human, until Jesus announces his intention to kill the devil and the devil responds by proclaiming how he caused John the Baptist’s death (chap. 5). Finally, Jesus splits open the earth and tells the devil how he will be tormented by angels until he is brought to the earth to go to Daphne in the land of Gouze. The devil is told he will be born from a woman named Eudokia and will reign for three years, during which time there will be an abundance of food in the first year, but not in the other two years. In this recension, the devil is told that he will be killed by Elijah, Enoch, the Virgin Mary, John the Baptist, and Jesus himself—primarily as punishment for causing the death of John the Baptist.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Church Slavic text comes in multiple recensions, though the version translated here is from a manuscript at St. Catherine’s monastery on Mount Sinai (Slav. 34). In general, the Church Slavic versions present a shortened rendering of the narration found in the Greek recensions. For example, chapter 1 in the Church Slavic version contains only three short exchanges, omitting entirely the question of why Jesus came to earth himself instead of sending angels, which is central to the Greek recension. In chapter 2, however, the Church Slavic tradition takes its own distinct path: it does so first in the description of the devil’s accomplices, where it focuses on sins rather than sinners, and some recensions provide an expanded list (2:4). The most obvious deviations are several edits in 2:6 made to reflect Bogomil theology (in one manuscript the devil describes himself as older than Jesus, and in another he is older than everyone), but the rest of the chapter is also markedly different: where the Greek text has the devil refer to the creation of Adam, the Church Slavic has Jesus and the devil trade accusations of being a deceiver. In chapter 3, both traditions cover the same ground, except where the Greek puts Temeluchus in charge of leading repentant sinners to paradise; in Church Slavic this task falls to Michael. As for chapters 5 and 6, the starkest difference between the traditions is in the transformation of Jesus into his divine form and back, which is lacking in the Church Slavic tradition. The Church Slavic recensions also significantly shorten the devil’s speech in chapter 6, omitting his comparison to Jesus, and, unlike the Greek text (recension A), have him confess to causing the death of John the Baptist (as in Greek recension B). And finally, in chapter 7, the Church Slavic version of the conversation over the newly opened gap in the earth replaces Jesus’s reference to the slaves rolling a heavy stone with a description of the depth of the gap and completely omits the reference to the devil’s mother.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Manuscripts and Editions")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The first edition of the Greek tradition of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" was published by Athanasius Vassiliev in 1893; in it he provided both recensions A and B."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-003",
      "id": "foot_003"
    }
  }, [_vm._v("3")])]), _vm._v(" He made use of two manuscripts: Venice, Biblioteca Nazionale Marciana, gr. II. 42 (coll. 1123), fols. 255r–257r (12th cent.; = M) and Vienna, Österreichische Nationalbibliothek, hist. gr. 67 (Lambeck 33), fols. 18r–19v (13th cent.; = V). These same manuscripts were republished in 1955 by Robert Casey and Robert Thomson,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-004",
      "id": "foot_004"
    }
  }, [_vm._v("4")])]), _vm._v(" who assigned them to recensions A (manuscript M) and B (V), along with English translations of two Church Slavic recensions published by Nikolaj Tichonravov in 1863."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-005",
      "id": "foot_005"
    }
  }, [_vm._v("5")])]), _vm._v(" Casey and Thomson reported also the existence of a potential third Greek manuscript of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" in Jerusalem (Patriarchikē bibliothēkē, Panagios Taphos gr. 66, fols. 178r–182r [15th/16th cent.; = J, also of recension A]),"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-006",
      "id": "foot_006"
    }
  }, [_vm._v("6")])]), _vm._v(" first recognized by J. Rendel Harris in his 1889 book "), _c('em', [_vm._v("The Rest of the Words of Baruch")]), _vm._v(". While the focus of this book is "), _c('em', [_vm._v("4")]), _vm._v(" "), _c('em', [_vm._v("Baruch")]), _vm._v(" (known in Greek as the "), _c('em', [_vm._v("Paraleipomena Jeremiou")]), _vm._v("),"), _c('em'), _vm._v(" Rendel Harris narrates how he returned to Jerusalem to copy the entirety of this “dispute of the devil” (Ἀντιλογία τοῦ διαβόλου), but he seemingly never published it and, Casey and Thomson report, “his transcript has not been found among his papers.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-007",
      "id": "foot_007"
    }
  }, [_vm._v("7")])]), _vm._v(" Casey and Thomson note that the transmission of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" in M"), _c('em'), _vm._v(" is complicated, since the codex has three identified scribes and the original parchment leaves of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" are no longer extant. Rather, fol. 255 is parchment added by Scribe 2 and fols. 256–57 are paper added by Scribe 3."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-008",
      "id": "foot_008"
    }
  }, [_vm._v("8")])]), _vm._v(" While Casey and Thomson do not comment on whether this affects the dating of M, it is nevertheless worth noting that our extant copy in M is not original to the manuscript.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Church Slavic"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-009",
      "id": "foot_009"
    }
  }, [_vm._v("9")])]), _vm._v(" manuscripts are more numerous and more complex than the Greek tradition. Aurelio de Santos Otero knew of fourteen Church Slavic manuscripts containing "), _c('em', [_vm._v("Dial. Devil")]), _vm._v("; Francis Thomson offered corrections to this list in his review of the volume."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-010",
      "id": "foot_010"
    }
  }, [_vm._v("10")])]), _vm._v(" Thomson added that no comparative study had yet been done (in the 1980s) between the Greek and Church Slavic redactions, and that several Russian codices not listed by de Santos Otero had "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" torn out because it was deemed apocryphal"), _c('em', [_vm._v(".")]), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-011",
      "id": "foot_011"
    }
  }, [_vm._v("11")])]), _c('em'), _vm._v(" Julian Petkov noted the existence of a fifteenth Church Slavic manuscript but failed to provide details."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-012",
      "id": "foot_012"
    }
  }, [_vm._v("12")])]), _vm._v(" Most recently, Anissava Miltenova has produced a list of eleven witnesses with at least some relation to the southern branch of the Church Slavic tradition of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(","), _c('em'), _vm._v(" some of which were unknown to both de Santos Otero and Petkov."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-013",
      "id": "foot_013"
    }
  }, [_vm._v("13")])]), _vm._v(" The full list of known manuscripts containing "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" is provided in the table below, where the manuscripts are ordered and assigned a capital letter siglum based on Miltenova’s list. In instances where Miltenova groups two or more manuscripts into a single entry, a number is added to the siglum on the basis of either the order given by Miltenova (e.g., J1 and J2) or that given in the source she cites (e.g., the K manuscripts). Manuscripts not on Miltenova’s list continue the numbering.")]), _vm._v(" "), _c('div', {
    staticClass: "top-left"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("A:")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Mount Sinai, Monē tēs Hagias Aikaterinēs, Slav. 34, fols. 72r–77r (12th/13th cent.; = de Santos Otero 14)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("B:")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Vienna, Österreichische Nationalbibliothek, Cod. Slav. 137, fols. 177r–178v (14th cent.; = de Santos Otero 10)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("C:")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Nikojac monastery, near Bijelo Polje, Montenegro, 52, fols. 66r–71r (15th cent.) (unpublished)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("D:")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sofia, SS. Cyril and Methodius National Library, 433 (629), fols. 101r–105v (16th cent.; = de Santos Otero 9)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("E:")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Vienna, Österreichische Nationalbibliothek, Cod. Slav. 149, fols. 113r–117v (16th cent.; = de Santos Otero 11) (unpublished)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("F:")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Belgrade, Museum of Serbian Orthodox Church, 100, fols. 84r–87v (1628) (unpublished)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("G:")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sofia, SS. Cyril and Methodius National Library, 326 (509), fols. 41r–44r (17th/18th cent.; = de Santos Otero 8) (unpublished)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("H:")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Belgrade, National Library of Serbia, 273, fols. 137v–143 (16th/17th cent.; = de Santos Otero 1)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("I:")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Prague, National Museum, IX. H.16 (Šafařík Collection 19), fols. 227r–231r (1646)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("J1:")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Kyibv, National Academy of Sciences, Institute for Literature, 4713, fols. 83–88 (16th/17th cent.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("J2:")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Saint Petersburg, National Library of Russia (F. 784), F. A. Tolstoj Collection, Otd. II, 229 (Q. XVII, 82), fols. 41–45 (1602; = de Santos Otero 3)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("K1:")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Saint Petersburg, National Library of Russia (F. 67), Berčić Collection 5, fols. 62–64 (15th cent.; = de Santos Otero 2)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("K2:")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Zagreb, Croatian Academy of Sciences and Arts, IV.a.48, fols. 93r–94v (15th cent.; = de Santos Otero 12)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("K3:")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Zagreb, Croatian Academy of Sciences and Arts, Cod. glagoliticus VII a 30, fols. 1–3 (16th cent.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("K4:")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Oxford, Bodleian Library, M. S. Can. Lit. 414, fols. 50r–51v (15th. cent.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("K5:")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Zagreb, Croatian Academy of Sciences and Arts, Fragm. glagol. 80, several disjointed lines (14th cent.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("L:")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Lemberg (?), manuscript owned by Father Jaremec"), _c('span', {
    staticClass: "special-char"
  }, [_vm._v("ǐ")]), _vm._v("kij-Bîlachevič, fols. 87–91 (16th/17th cent.; = de Santos Otero 5)"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-014",
      "id": "foot_014"
    }
  }, [_vm._v("14")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("M:")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Moscow, State Historical Museum, A. S. Uvarov Collection 66, folios not provided (18th cent.; = de Santos Otero 6)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("N:")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Belgrade, National Library of Serbia, 760, fols. 61r–68v (16th cent.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("O:")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Cavtat (Croatia), Archive of Baltazar Bogišić, 2a, fols. 35r–38v (16th/17th cent.) (unpublished)")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Considering the popularity of the text—as evidenced by the many extant manuscripts, originating in virtually all corners of the Slavic-speaking world—it is no surprise that "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" has attracted the attention of Slavistics since the early days of modern study of Church Slavic apocrypha. The oldest scholarly work on "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" is—as is the case with many such works preserved in Church Slavic—Aleksandr Pypin’s collection of Old Russian apocrypha and pseudepigrapha,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-015",
      "id": "foot_015"
    }
  }, [_vm._v("15")])]), _vm._v(" in which Pypin published an edition from a manuscript of Russian provenance (J2). A year later, Tichonravov re-edited the same text along with another one from a different Russian manuscript (M)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-016",
      "id": "foot_016"
    }
  }, [_vm._v("16")])]), _vm._v(" These two versions form the core of the first group of Church Slavic recensions of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(", those of Eastern Slavic origin (henceforth group α), and are the only ones that have been translated into English."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-017",
      "id": "foot_017"
    }
  }, [_vm._v("17")])]), _vm._v(" The third member of group α is J1,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-018",
      "id": "foot_018"
    }
  }, [_vm._v("18")])]), _vm._v(" which is related to the other two in both origin and language. Preserved in a manuscript owned by one father Teodor of Dub"), _c('span', {
    staticClass: "special-char"
  }, [_vm._v("ǐ")]), _vm._v("vec,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-019",
      "id": "foot_019"
    }
  }, [_vm._v("19")])]), _vm._v(" it was edited and published by Ivan Franko."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-020",
      "id": "foot_020"
    }
  }, [_vm._v("20")])]), _vm._v(" Franko recognized the text’s obvious affinity with those published by Tichonravov, describing them as “belonging to the same type,” but noted obvious differences as well as some degree of Serbian influence."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-021",
      "id": "foot_021"
    }
  }, [_vm._v("21")])]), _vm._v(" The fourth and final member of this group is L, also published by Franko."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-022",
      "id": "foot_022"
    }
  }, [_vm._v("22")])]), _vm._v(" As Franko notes, however, this version is not related to M, J1, or J2; furthermore, it stands apart from the fellow members of group α linguistically: where the other three are written in more or less standard Church Slavic (modulo regional variation), the language of L is much closer to modern Slavic vernaculars (more specifically, Ukrainian) than to Church Slavic.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The second group of Church Slavic recensions (henceforth β) comprises manuscripts of clear South Slavic provenance (with the exception of Croatia, on which see below). These include our A (edited by Miltenova"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-023",
      "id": "foot_023"
    }
  }, [_vm._v("23")])]), _vm._v("), B (edited by Konstantin F. Radčenko and Jordan Ivanov"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-024",
      "id": "foot_024"
    }
  }, [_vm._v("24")])]), _vm._v("), D (edited by Ivanov and translated into modern Bulgarian by Petkanova"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-025",
      "id": "foot_025"
    }
  }, [_vm._v("25")])]), _vm._v("), H (edited by Stojan Novaković;"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-026",
      "id": "foot_026"
    }
  }, [_vm._v("26")])]), _vm._v(" the manuscript was destroyed in World War II), and I (edited by Georg Jiří Polívka"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-027",
      "id": "foot_027"
    }
  }, [_vm._v("27")])]), _vm._v("). Several unedited manuscripts belong here as well: C, E, F, and G, as well as two new discoveries noted by Miltenova (N and O)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-028",
      "id": "foot_028"
    }
  }, [_vm._v("28")])]), _vm._v(" Of particular interest are two members of this group: A and B. A is primarily interesting because of its age, as it dates to the twelfth/thirteenth century and is thus the oldest Church Slavic witness of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(". This manuscript is the base text for the translation here. B, in contrast, is unique in some of its readings, particularly 2:6, which casts the text in a new light: the devil’s statement to Jesus “I am older than you” (where other recensions and the Greek text have “I am stronger than you”) hints at a dualistic understanding of the relationship between them, characteristic of Bogomil theology.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The third and final group of Slavic recensions (henceforth γ) is set apart by its written form and origin: this group contains five manuscripts from Croatia written in Croatian (square) Glagolitic script. The Croatian Glagolitic texts are typically considered to stand apart from the rest of the Church Slavic tradition for two reasons. First, Glagolitic was generally abandoned by the twelfth century in favor of the simpler Cyrillic script. The only exception is Croatia, where it experienced a revival in the thirteenth century and was in use well into the eighteenth century. Second, unlike the rest of the Slavic world where Church Slavic was used as the main written language and which belonged to the Byzantine rite, Croatia has always been a Catholic country. Consequently, the cultural and literary (not to mention linguistic) context of writings in Croatian Glagolitic is markedly different from those of, say, Bulgarian or Ukrainian provenance, since most texts preserved in Croatian Glagolitic are translations from Latin of liturgical texts, the Vulgate, legal codices, and lives of saints. That being said, Croatia was never completely cut off from Eastern Christianity and its literary production. Whether Croatian Glagolitic recensions of such popular works as the "), _c('em', [_vm._v("Physiologus")]), _vm._v(" are an example of that is doubtful; given that the oldest extant manuscripts date to the fifteenth century, it was probably made from Latin."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-029",
      "id": "foot_029"
    }
  }, [_vm._v("29")])]), _vm._v(" However, there is a tradition of Croatian Glagolitic apocryphal literature where, at least for a part of it, Greek is the most likely ultimate source of transmission. One prominent example is the "), _c('em', [_vm._v("Acts of Andrew and Matthias")]), _vm._v(", which is preserved in two Croatian Glagolitic manuscripts, one from the fifteenth century, the other from the sixteenth."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-030",
      "id": "foot_030"
    }
  }, [_vm._v("30")])]), _vm._v(" Neither is an original translation, but a reworking of an earlier translation into Church Slavic, most likely of Bulgarian provenance."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-031",
      "id": "foot_031"
    }
  }, [_vm._v("31")])]), _vm._v(" The Croatian Glagolitic recensions of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" followed the same path as "), _c('em', [_vm._v("Acts Andr. Mth.")]), _vm._v(","), _c('em'), _vm._v(" with one distinction: "), _c('em', [_vm._v("Acts Andr. Mth.")]), _vm._v(" was a wildly popular work, as witnessed by the many Greek manuscripts and translations; "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" is only preserved in Greek and Church Slavic. It is therefore remarkable that no less than five recensions of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" are preserved in the Croatian Glagolitic variety of Church Slavic.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The five manuscripts in the group γ were edited by Slavomir Sambunjak."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-032",
      "id": "foot_032"
    }
  }, [_vm._v("32")])]), _vm._v(" Sambunjak includes "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" in a larger collection of texts that fall under the umbrella of medieval debate poetry ("), _c('em', [_vm._v("Streitgedicht")]), _vm._v(") preserved in Croatian Glagolitic, such as the widely known and translated "), _c('em', [_vm._v("Visio Philiberti")]), _vm._v(" or the original Croatian composition "), _c('em', [_vm._v("Slovo meštra Polikarpa")]), _vm._v("."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-033",
      "id": "foot_033"
    }
  }, [_vm._v("33")])]), _vm._v(" The ubiquity of this genre might then explain the popularity of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" in medieval Croatia. Sambunjak does, however, recognize the unique nature of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" and, on the basis of the comparatively late dating of the Croatian Glagolitic manuscripts (none predates the fourteenth century), postulates that they were transcribed (and re-edited) from Church Slavic recensions originally composed in Cyrillic."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-034",
      "id": "foot_034"
    }
  }, [_vm._v("34")])]), _vm._v(" Of the five manuscripts (designated K1–K5), one (K5) is merely a fragment, containing bits of chapter 7; another (K1) is incomplete at the beginning. K1 is also remarkable for two more reasons: first, like L in group α and much more so than the other four Croatian Glagolitic recensions, its language shows the influence of the modern vernacular (more specifically, the čakavian dialects of Croatian); second, it agrees with the Bogomil version of 2:6 in recension B, with K1 having the devil say, “I am greater than your (angels) and older than everyone.” The remaining three witnesses are preserved complete: K2 and K3 can most likely be traced to a single archetype, while K4 deviates from them in a number of ways.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Analysis of the Church Slavic Tradition")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Even a cursory look at the extant published Church Slavic recensions makes it obvious that the Church Slavic tradition of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" is not a straightforward branch of the Greek one in the traditional view of textual criticism. Rather, the Church Slavic recensions are an extreme example of an open tradition where many (if not most) extant manuscripts contain versions of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" that have obviously undergone significant editorial changes. As a result, there is not a single pair of extant published manuscripts—with the possible exception of K2 and K3—that can be traced to a single archetype. And while the manuscripts generally present the same narrative elements, they do not agree on even the simplest of details, such as ages or distances. For the purposes of our analysis, we will therefore consider each manuscript a separate recension and will refer to them as such.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The primary instances of editorial intervention are recensions M and L, which reveal their nature as re-edits even without a careful comparison of their contents with other traditions. M does so by combining a retelling of the temptation narrative from Matt 4:1–11 and Luke 4:1–13 with the narrative of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" known from other recensions. L, in turn, is an obvious adaptation of (a version of) the Church Slavic text of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" into a version of Church Slavic very close to the local vernacular—i.e., Ukrainian. In addition to that, the conclusion of L (7:12–16) is different from that of the rest of the tradition.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Both those modifications can also be observed in the Croatian Glagolitic recensions: K2, K3, and K4 add to the beginning of the narrative an episode where the devil in the form of a person tempts Jesus with avarice, worldly fame, and riches, but ultimately fails. Additionally, they all diverge from the rest of the tradition at 7:5 to provide a different ending: K4 concludes the text with a homiletic section listing occasions in the Bible where prayer and fasting (typically for forty days) saves someone, K1 ends abruptly with Jesus telling the devil to enter the abyss, and K2 and K3 describe Jesus’s and his disciples’ return to Jerusalem and admonish the readers to fast and pray. And as in L, all Croatian Glagolitic versions—save one—show clear signs of being adapted to local vernaculars. As Sambunjak notes,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-035",
      "id": "foot_035"
    }
  }, [_vm._v("35")])]), _vm._v(" it is only the oldest Croatian Glagolitic recension, the fragmentary K5, that can be clearly described as written in what he terms the Church Slavic koine; the K2, K3, and K4 recensions gradually take on more and more characteristics of the spoken language of their environment—namely, the čakavian dialect of Croatian—with K1 being the closest to the Church Slavic norm, K3 the furthest away from it, K4 closer to K1, and K2 almost as colloquial as K3.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Comparing the content of individual recensions more closely reveals even more ways in which they have been rewritten and re-edited. Sometimes the edits are of a theological nature; one such instance is the aforementioned purported Bogomil edits in "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" 2:6 in B and K1 where the devil describes himself as older than Jesus (B) or older than everyone (K1). Another theological edit, which also illustrates the level of the disagreement between the recensions, can be found in 5:3–5. This section has Jesus asking, “Who cast the devil from heaven?” and his apostles respond. Not even such a simple chain of events is described in the same way in all Church Slavic recensions, as both the wording of the answer and the identity of the one providing it differ: Philip is the one who answers in B; Philip and Bartholomew in M; Peter in D, I, J1, and K1; John in L; John and Jacob in J1, K2, K3, and K4; “his disciples” in H; and the answer is given without an attribution in J2. Two manuscripts have two answers: In A, the first answer is given by John, the other by Peter. K1 even repeats the question twice: the first exchange has Thomas, Philip, Bartholomew, and John respond, “God is above all,” and in the second exchange, it is Peter who responds. The actual answer to Jesus’s question is much less varied: where B and D answer “your father,” H, J1, and M answer “you and your father,” and the remaining manuscripts reference all three persons in the Trinity in various wordings. Only I, however, does so with the standard formulation of “three persons, one God in three divine persons, Father and Son and the Holy Spirit.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("One of the most salient examples of the adaptation of the text to local language and environment is "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" 2:4: this verse includes a list of the devil’s works and, unsurprisingly for this tradition, the list is never the same in the recensions. Nevertheless, the different versions of the list contain more or less the same items, if in different order, divided into three major groups: the deadly sins, natural catastrophes, and war and conflict. The one recension that stands out is J2: where in the remaining recensions the list of the devil’s works consists of ten to fifteen items, J2 has twenty-three, including a number of peculiar ones, like “clapping” ("), _c('em', [_vm._v("pleskanîe")]), _vm._v(") and “wicked games” ("), _c('em', [_vm._v("igranîe nepodobnoe")]), _vm._v("). These terms describe folk festivals, especially those associated with rusalia, a spring festival that, after the Christianization of the Slavic world, became connected with the Pentecost. In Russia, these festivals often featured processions with loud music, dancing, and rituals dating back to the pre-Christian era; as a result, they were a frequent target of medieval Russian sermons admonishing pagan practices. One prominent example is the twelfth-century translation of the hagiography of Saint Niphon, bishop of Cyprus (4th cent.), compiled in Russia."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-036",
      "id": "foot_036"
    }
  }, [_vm._v("36")])]), _vm._v(" This translation features an entire section, not present in the original Greek, decrying these customs as “satisfying the needs of evil spirits,” where the word for “evil spirit” is "), _c('em', [_vm._v("běs")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǔ")]), _vm._v(", the same word that only J1, J2, L, and M (i.e., all East Slavic recensions) use to describe the devil’s army in "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" 4:1–2."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-037",
      "id": "foot_037"
    }
  }, [_vm._v("37")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("And finally, three Church Slavic recensions raise a question of local adaptation in terms of their "), _c('em', [_vm._v("Sitz im Leben")]), _vm._v(". K3, K4, and M all bear a title similar to that of prescribed liturgical readings: “Reading (on the) fifth Sunday of Lent” (K3), “Teaching for first Sunday of Lent after Matthew” (K4), and “For Great Friday, on the fasting and on the dispute between the Lord and the devil” (M). Would this then mean that the text, in one of its Greek or Church Slavic forms, was a part of the liturgy at least in some parts of the Slavic world? The homiletic additions at the end of K3 and K4 (and the same ending of K2) would certainly support this conclusion. Whether the cultural and religious milieu in which K2, K3, and K4 were produced—i.e., the Catholic liturgy—allows for this is a question that deserves a deeper study than can be offered here. Nevertheless, this differs from the incipits of the Greek manuscripts of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(","), _c('em'), _vm._v(" which"), _c('em'), _vm._v(" are transmitted in miscellany codices and simply describe the content of the text. A liturgical use of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v("—albeit locally rather than universally in the medieval or early modern period—would challenge any strict division between “liturgical/homiletic” and “apocryphal” texts. As Péter Tóth has noted, Byzantine apocrypha and "), _c('em', [_vm._v("erōtapokriseis")]), _vm._v(" literature are often related and borrow from one another; for example, "), _c('em', [_vm._v("2 Apocryphal Apocalypse of John")]), _vm._v(" shares questions regarding the liturgy with "), _c('em', [_vm._v("Various Questions and Answers on Priests")]), _vm._v(" and Germanos of Constantinople’s "), _c('em', [_vm._v("Ecclesiastical History and Mystical Contemplation")]), _vm._v("."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-038",
      "id": "foot_038"
    }
  }, [_vm._v("38")])]), _vm._v(" Coptic texts such as the "), _c('em', [_vm._v("Investiture of the Archangel Michael")]), _vm._v(" similarly incorporate both apocryphal and liturgical elements so as to disturb any clear demarcation between the two. The same might be said of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v("—namely, that it exists in the liminal space between Byzantine apocrypha and liturgical texts, while simultaneously utilizing dialogue and "), _c('em', [_vm._v("erōtapokriseis")]), _vm._v(" literature and traditions in more subtle ways.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Theological Considerations")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', [_vm._v("Dial. Devil")]), _vm._v(" contributes to our understanding of Byzantine conceptions of the devil and the antichrist."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-039",
      "id": "foot_039"
    }
  }, [_vm._v("39")])]), _vm._v(" Unlike other portrayals of the antichrist as the devil’s son (e.g., Ps.-Hippolytus, "), _c('em', [_vm._v("Antichr.")]), _vm._v(" 15:1), here the antichrist is the devil incarnate."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-040",
      "id": "foot_040"
    }
  }, [_vm._v("40")])]), _vm._v(" The devil is accused of misleading Adam and chasing him out of paradise (2:3), as well as refusing to worship Adam when he was created (3:2) and attempting to spit on Jesus (6:2 in Greek B)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-041",
      "id": "foot_041"
    }
  }, [_vm._v("41")])]), _vm._v(" "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" works within previous and concurrent traditions of the devil opposing Adam’s creation and jealously deceiving him and Eve. For example, the various recensions and translations of the "), _c('em', [_vm._v("Life of Adam and Eve")]), _vm._v(" present the devil as failing to worship Adam, being exiled from heaven, attempting to establish a throne in heaven, and misleading Eve as punishment against Adam (12:1–17:3)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-042",
      "id": "foot_042"
    }
  }, [_vm._v("42")])]), _vm._v(" Similarly, the Qur"), _c('span', {
    staticClass: "special-char"
  }, [_vm._v("ʼ")]), _vm._v("an transmits a tradition in which Iblis fails to worship the created Adam, is cast out of heaven until judgment day, deceives Adam and Eve to eat from the tree of knowledge, and demands permission to mislead humanity."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-043",
      "id": "foot_043"
    }
  }, [_vm._v("43")])]), _vm._v(" The tradition occurs also in several interrelated Coptic apostolic memoirs."), _c('em'), _vm._v(" Here Jesus descends to save Adam and his children ("), _c('em', [_vm._v("Invest. Mich.")]), _vm._v(" 3:15; "), _c('em', [_vm._v("Invest. Abbat.")]), _vm._v(" 5:12–13), and the devil once more refuses to worship Adam; for his impertinence, he is thrown out of heaven ("), _c('em', [_vm._v("Invest. Mich.")]), _vm._v(" 3:29–38; "), _c('em', [_vm._v("Invest. Abbat.")]), _vm._v(" 6; "), _c('em', [_vm._v("Invest. Gab.")]), _vm._v(" 9:6–8)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-044",
      "id": "foot_044"
    }
  }, [_vm._v("44")])]), _vm._v(" Similar narratives appear in Greek texts like the "), _c('em', [_vm._v("Apocalypse of Sedrach")]), _vm._v(" and "), _c('em', [_vm._v("Questions of Bartholomew.")]), _vm._v(" In the former text, Adam is placed in paradise but is deceived to eat by the devil (4:4–5), leading Sedrach to question why God would not kill the devil and end his torment of humanity."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-045",
      "id": "foot_045"
    }
  }, [_vm._v("45")])]), _vm._v(" Sedrach challenges God’s judgment and asks a question that "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" shares almost verbatim: “If someone lives eighty or ninety or a hundred years, and lives them in sin but in the end is converted and lives in repentance, for how many days of repentance do you forgive their sins?” (12:5), to which God answers three years. While "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" does not ask how long one needs to repent in order to be saved, it does"), _c('em'), _vm._v(" present the devil as having three years to reign on the earth in its final days (7:5), so perhaps those three years are meant to give humanity time to repent."), _c('em'), _vm._v(" In "), _c('em', [_vm._v("Quest. Bart.")]), _vm._v(","), _c('em'), _vm._v(" Beliar is trapped by Bartholomew and explains how God and Michael formed Adam as the image of God, as well as how the devil refused to worship such a creature since he himself was the first angel created (4:52–58). God then casts out Satan and six hundred angels, who are knocked unconscious for forty years before beginning their plot against Adam."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-046",
      "id": "foot_046"
    }
  }, [_vm._v("46")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Dial. Devil")]), _vm._v(" also presents a particular tradition regarding the death of the devil and his fate as ruler of the earth (7:6–9). As noted earlier, the devil is given three years to reign across the "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" recensions, which the text shares with "), _c('em', [_vm._v("1 Apocryphal Apocalypse of John")]), _vm._v(". This is perhaps a time period comparable to the “time, times, and half a time” of Daniel (7:25; 9:27; 12:7, 11–12; cf. Rev 11:2; 12:14; 13:5)—often interpreted as three and a half years—or the tradition of the "), _c('em', [_vm._v("Ascension of Isaiah")]), _vm._v(" in which Beliar reigns for three years, seven months, and twenty-seven days, after which time Jesus and his armies will drag Beliar to gehenna ("), _c('em', [_vm._v("Ascen. Isa.")]), _vm._v(" 4:12)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-047",
      "id": "foot_047"
    }
  }, [_vm._v("47")])]), _vm._v(" As noted above, the time of the devil’s reign might also correlate to the amount of time that God allows for repentance in "), _c('em', [_vm._v("Apoc. Sedr.")]), _vm._v(" In any case, "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" draws on Jesus’s divine ability to shorten time (Ps 88:45; 89:4 LXX; Mark 13:20//Matt 24:22; "), _c('em', [_vm._v("1 Apocr. Apoc. John")]), _vm._v(" 8:2–3; "), _c('em', [_vm._v("Tib. Sib.")]), _vm._v(" 8:2), so that God will diminish the devil’s short reign on earth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Dial. Devil")]), _vm._v(" also shares with "), _c('em', [_vm._v("1 Apocr. Apoc. John")]), _vm._v(" two other traditions: the slaughter of the devil by Enoch and Elijah, and the presence of Temeluchus as an agent of punishment (depending on the recension). Both texts seemingly draw on Rev 11:3–13, in which God grants two witnesses authority to prophesy for the three and a half years, who can spit fire at anyone who harms them, plague the earth, kill the beast who emerges from the bottomless pit, and themselves die in “the great city that is prophetically called Sodom and Egypt, where also their Lord was crucified” (Rev 11:8). While "), _c('em', [_vm._v("1 Apocr. Apoc. John")]), _vm._v(" 8:5 presents Enoch and Elijah accusing the devil and being killed by him on an altar (cf. "), _c('em', [_vm._v("Apoc. El.")]), _vm._v(" 5:32–35), various "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" recensions depict the Virgin Mary and John the Baptist, along with Enoch and Elijah, in killing the devil. Particularly in Greek B, John the Baptist is included in this list of murderers of the devil because he seemingly deserves justice or revenge for being beheaded by Herod at the devil’s instigation. Since the devil denies having tempted Herod in Greek A, there is no reason for John the Baptist to be involved. There is also a related tradition in the "), _c('em', [_vm._v("(Latin) Revelation of John about Antichrist")]), _vm._v(","), _c('em'), _vm._v(" in which the antichrist kills Enoch and Elijah and they lie dead on the street until they are resurrected and Michael arrives to slay the devil ("), _c('em', [_vm._v("Rev. John Ant.")]), _vm._v(" 5:1–5; cf. "), _c('em', [_vm._v("Apoc. Dan.")]), _vm._v(" 14; Ps.-Hippolytus, "), _c('em', [_vm._v("De consummatione mundi")]), _vm._v(" 21; "), _c('em', [_vm._v("Tib. Sib.")]), _vm._v(" 8:5–6)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-048",
      "id": "foot_048"
    }
  }, [_vm._v("48")])]), _vm._v(" By the tenth century, Adso notes that former writers believed that either Jesus or Michael will kill the antichrist on the Mount of Olives—a tradition shared with some hadith regarding Jesus returning to kill Dajjal."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-049",
      "id": "foot_049"
    }
  }, [_vm._v("49")])]), _vm._v(" Seemingly, the tradition preserved in "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" follows Rev 11 regarding the two prophetic witnesses confronting the devil but does not continue with their own deaths; rather, they seem to be resurrected for this very purpose. "), _c('em', [_vm._v("1 Apocr. Apoc. John")]), _vm._v(" and "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" also share the character of Temeluchus, presented in the apocalypse (after 27:6 in manuscript E of the text)"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-050",
      "id": "foot_050"
    }
  }, [_vm._v("50")])]), _vm._v(" as the primary agent of punishment who commands the keepers of hell and gathers sinners to be melted; in "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" he is the mediator between the earth and hell for unrepentant souls (2:6). Such a number of similarities led Yavor Miltenov to suggest that "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" is textually dependent on "), _c('em', [_vm._v("1 Apocr. Apoc. John.")]), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-051",
      "id": "foot_051"
    }
  }, [_vm._v("51")])]), _vm._v(" However, Temeluchus appears elsewhere across apocryphal traditions, such as the Ethiopic "), _c('em', [_vm._v("Apocalypse of Peter")]), _vm._v(" 8, "), _c('em', [_vm._v("Meqabyan")]), _vm._v(" (Ethiopic "), _c('em', [_vm._v("Maccabees")]), _vm._v("), and the "), _c('em', [_vm._v("Apocalypse of Paul/Visio Pauli.")]), _vm._v(" In "), _c('em', [_vm._v("Apoc. Paul")]), _vm._v(","), _c('em'), _vm._v(" this figure is the one in charge of torments and casting sinners into the outer darkness (15, 18), who has a flaming pitchfork (34)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-052",
      "id": "foot_052"
    }
  }, [_vm._v("52")])]), _vm._v(" While images of the devil and Temeluchus are sometimes conflated in modern conceptions of Satan, "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" treats the angelic tormenter as quite distinct from the devil.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("One of the most puzzling aspects of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" is the location at which the devil is supposed to meet his fate. In Greek A, the devil must go to “Gouze, the land of the Egyptians” (6:4), after he is born from Perdition ("), _c('em', [_vm._v("Ap")]), _c('em', [_vm._v("ō")]), _c('em', [_vm._v("leia")]), _vm._v("; cf. 2 Thess 2:3) and completes his three-year reign, to be slaughtered. In Greek B, the devil is told to go to “the city of Daphne in the land of Gouze” in order to be sold in the meat market like a pickled fish,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-053",
      "id": "foot_053"
    }
  }, [_vm._v("53")])]), _vm._v(" as well as to be born from the virgin Eudokia because he must be born of Injustice ("), _c('em', [_vm._v("Adikia")]), _vm._v("). The majority of the Church Slavic recensions omit this passage; only A, D, I, and J2 include the reference to the city, where A, D, and J2 refer to it as "), _c('em', [_vm._v("Chizi")]), _vm._v(", while I2 has "), _c('em', [_vm._v("Chižina")]), _vm._v(" (a word that could also mean “hut, shack,” so this may be a scribal error). The phonology of the Church Slavic equivalents, especially the initial consonant (the "), _c('em', [_vm._v("ch")]), _vm._v(" in Scottish "), _c('em', [_vm._v("loch")]), _vm._v("), which would not be obtained in Church Slavic from the Greek "), _c('em', [_vm._v("gamma")]), _vm._v(", offers the possibility that these recensions were made from a Greek original that contained a different name. Without any textual evidence, however, this remains a mere speculation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("While the location of this city is unknown to Casey and Thomson,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-054",
      "id": "foot_054"
    }
  }, [_vm._v("54")])]), _vm._v(" others argue that the site of Daphne (also known as Tahpanhes) on the northeastern side of the Delta is a candidate."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-055",
      "id": "foot_055"
    }
  }, [_vm._v("55")])]), _vm._v(" Klaus Berger recognized that a similar city name, Gouzeth, appears in the ninth-century "), _c('em', [_vm._v("Apocalypse of Daniel")]), _vm._v(","), _c('em'), _vm._v(" based on which Berger argues that both "), _c('em', [_vm._v("Apoc. Dan.")]), _vm._v(" and "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" are referring to Kush (Greek "), _c('em', [_vm._v("Chous")]), _vm._v("; "), _c('em', [_vm._v("Chouse")]), _vm._v(")."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-056",
      "id": "foot_056"
    }
  }, [_vm._v("56")])]), _vm._v(" Another possibility is that this name is tied to Chouseth, the daughter of the king of Ethiopia who is identified as the mother of Alexander the Great—and, later, the wife of Byzas, founder of Byzantium—in the "), _c('em', [_vm._v("Apocalypse of Ps.-Methodius")]), _vm._v("."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-057",
      "id": "foot_057"
    }
  }, [_vm._v("57")])]), _vm._v(" In either case, "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" might be following the antichrist tradition present in Ps.-Athanasius’s seventh-century "), _c('em', [_vm._v("Quaestiones ad Antiochem ducem")]), _vm._v(","), _c('em'), _vm._v(" a Byzantine collection of 137 questions and answers regarding Christianity’s relationship to Hellenism and Judaism. "), _c('em', [_vm._v("Quaest. ad Ant.")]), _vm._v(" 109 asks: “And is it true, that the Antichrist will emerge from Egypt?” (PG 28:664D–665), to which the answerer refutes such a fable and claims that the antichrist will come from Scythopolis. Even while denying that the antichrist is associated with Egypt, "), _c('em', [_vm._v("Quaest. ad Ant.")]), _vm._v(" preserves an early Byzantine tradition of such a story being told. As David Frankfurter notes, the “Land of Egypt oracle” is a long-standing Egyptian tradition continuing from the New Kingdom through late antiquity that imagines “the effects of kingship and ‘antikingship’ and articulate[s] the nature of Egypt as a sacred landscape whose fortunes responded to divine presence.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-058",
      "id": "foot_058"
    }
  }, [_vm._v("58")])]), _vm._v(" The aforementioned texts understand the land of Egypt as central to a Christianized apocalyptic scenario in which the antichrist will emerge in or be (re)born from Egypt and will be confronted there.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Finally, the name given to the mother of the devil in the Greek recensions is equally troubling. Greek A presents her clearly as Perdition, referring to the “son of perdition” appearing in both John 17:12 and 2 Thess 2:3. In the former, the clear referent is Judas Iscariot; in the latter, the figure is more obscurely referred to as the “man of lawlessness” who will be revealed and doomed to destruction in the day of the Lord. Greek A evidently took these passages literally, associated the “son of perdition” with the antichrist, and thus hypostatized the mother of the devil into the woman Perdition."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-059",
      "id": "foot_059"
    }
  }, [_vm._v("59")])]), _vm._v(" However, Greek B is more difficult to follow. This recension also hypostatizes a vice, Injustice, into the prophesied mother of the devil/antichrist. But the mother’s name is given as Eudokia, and the justification for her role as mother is “because you ought to be born from injustice.” This woman purchases the devil/antichrist as a fish and then bears him. This odd narrative is explained further in "), _c('em', [_vm._v("Apoc. Dan.")]), _vm._v(" 9:1–13,"), _c('em'), _vm._v(" in which the antichrist comes into a garidion fish in order to be caught by one of the twelve fishermen (i.e., the apostles) so as to win over Judas. The fish-antichrist is sold off at a market in Gouzeth by Judas for thirty silver pieces and is purchased by Injustice-Perdition, who becomes pregnant with the antichrist when she touches the head of the fish and carries him for three months. Thus, the antichrist mimics Christ by also"), _c('em'), _vm._v(" becoming incarnate of a virgin in this Byzantine tradition."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-060",
      "id": "foot_060"
    }
  }, [_vm._v("60")])]), _vm._v(" One might also look to Gregory of Nyssa’s comparison of the devil to a fish or dragon caught by a fishhook with the incarnate Christ as bait for evidence of the continuation of the devil-as-fish motif in late antiquity."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-061",
      "id": "foot_061"
    }
  }, [_vm._v("61")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("While Klaus Berger contends that this name change from Adikia to Eudokia in "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" is simply a scribal error, Jacques van der Vliet argues that it may be a reference to the fifth-century empress Eudokia, wife of Theodosius II, who was well known for siding with the anti-Chalcedonians at the Council of Chalcedon and may have been distrusted by monophysite leaders."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-062",
      "id": "foot_062"
    }
  }, [_vm._v("62")])]), _vm._v(" Beyond this, van der Vliet suggests that a fifth-century Palestinian monk copying "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" may have inserted this Eudokia pun to make the virgin of Daphne into the Byzantine empress, who is then fatally passionate about a fish and bears the antichrist. "), _c('em', [_vm._v("Apoc. Dan.")]), _vm._v(" combines these two traditions (albeit without Eudokia), so that the antichrist is born in Gouzeth from a virgin named Injustice ("), _c('em', [_vm._v("Adikia")]), _vm._v("), whose surname will be Perdition ("), _c('em', [_vm._v("Ap")]), _c('em', [_vm._v("ō")]), _c('em', [_vm._v("leia")]), _vm._v("; "), _c('em', [_vm._v("Apoc. Dan.")]), _vm._v(" 9:9–11). While van der Vliet’s suggestion is tantalizing, it seems more likely that the addition of Eudokia arose as a scribal error from Adikia.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Date and Provenance")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Regarding the date of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(","), _c('em'), _vm._v(" it is difficult to narrow the time frame to anything more than a window of multiple centuries. The earliest known sources include the two Greek manuscripts from the Biblioteca Nazionale Marciana (12th cent.) and the Österreichische Nationalbibliothek (13th cent.), as well as a Church Slavic manuscript from St. Catherine’s Monastery (12th/13th cent.), thereby making the twelfth century the "), _c('em', [_vm._v("terminus ante quem.")]), _vm._v(" To our knowledge, "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" is not mentioned in any late ancient or early medieval commentaries or scholia, and so cannot be traced back further through such a citation. Little is known about the provenance of "), _c('em', [_vm._v("Dial. Devil.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Regarding a "), _c('em', [_vm._v("terminus post quem")]), _vm._v(","), _c('em'), _vm._v(" Radčenko argues that "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" is contaminated by the influences of the Bogomils, a tenth-century dualist sect emerging from the Balkans."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-063",
      "id": "foot_063"
    }
  }, [_vm._v("63")])]), _c('em'), _vm._v(" Émil Turdeanu, on the other hand, has suggested that it is unlikely that "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" originated among or was influenced by the Bogomils, in large part due to the text’s non-Bogomil characteristics—e.g., humanity as created by God, the cult of the Virgin, and respect for the prophets and John the Baptist."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-064",
      "id": "foot_064"
    }
  }, [_vm._v("64")])]), _vm._v(" Likewise, Vassiliev suggests potential Manichaean or Paulician influence, thereby placing "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" in a seventh- or eighth-century context."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-065",
      "id": "foot_065"
    }
  }, [_vm._v("65")])]), _vm._v(" The Greek version of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" makes use of traditions present in other late ancient and Byzantine texts, such as the "), _c('em', [_vm._v("Tiburtine Sibyl")]), _vm._v(" (4th cent.), "), _c('em', [_vm._v("1 Apocr. Apoc. John")]), _vm._v(" (5th–8th cent.), and "), _c('em', [_vm._v("Apoc. Dan.")]), _vm._v(" (9th cent.), but it is unclear if any of these texts directly borrow material from one another or from other sources, as well as which direction the borrowing occurs for the more difficult texts to date. Establishing a time of composition is difficult also because of the lack of references to larger political events in late antiquity or to the rise of Islam (e.g., as one finds in "), _c('em', [_vm._v("Apoc. Ps.-Meth.")]), _vm._v(", "), _c('em', [_vm._v("Apoc. Ps.-Ephrem")]), _vm._v(", or "), _c('em', [_vm._v("Apoc. Dan.")]), _vm._v("). "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" participates in a tradition of the antichrist emerging from Egypt, as seen in the seventh-century "), _c('em', [_vm._v("Quaest. ad Ant.")]), _vm._v(","), _c('em'), _vm._v(" but does not make use of the narrative of Satan emerging from Bethsaida and Chorazin, nor of the antichrist being a Jew from the tribe of Dan, such as is preserved in Adso of Montier-en-Der’s tenth-century "), _c('em', [_vm._v("De ortu et tempore Antichristi")]), _vm._v("."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-066",
      "id": "foot_066"
    }
  }, [_vm._v("66")])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Translation")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Chance Bonar provides here a translation of the Greek Jerusalem manuscript (J) and Slavomír Čéplö the Church Slavic Sinai manuscript (A), translated here for the first time in any modern language. For the Greek text, variants from M and V are included in the footnotes. Chapter divisions proposed by Casey and Thomson are used with modifications. In light of the complexity of the Church Slavic tradition, providing a critical translation would not be possible; instead, the notes contain the most important deviations from the text of A and are provided to give the reader an overview of the development of the Church Slavic tradition.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-h1"
  }, [_vm._v("Bibliography")]), _vm._v(" "), _c('p', {
    staticClass: "bib-h2"
  }, [_vm._v("EDITIONS AND TRANSLATIONS")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Casey, Robert P., and Robert W. Thomson. “A Dialogue between Christ and the Devil.” "), _c('em', [_vm._v("JTS")]), _vm._v(" n.s. 6, no. 1 (1955): 49–65. (Editions of Greek M and V, pp. 50–55; translations of Church Slavic J2 and M, pp. 55–60.)")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Franko, Ivan. "), _c('em', [_vm._v("Apokrifi î legendy z ukraïns")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǐ")]), _c('em', [_vm._v("kich rukopisiv")]), _vm._v(". 5 vols. Lviv: Nakladom Naukovoho Tovaristva îmeni Ševčenka, 1898. (Editions of Church Slavic J1 and L, 2:196–203.)")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Ivanov, Jordan. "), _c('em', [_vm._v("Bogomilski knigi i legendi.")]), _vm._v(" Sofia: Pridvorna pečatnica, 1925. (Reprinting of Radčenko’s edition of Church Slavic B, pp. 249–53.) French translation by Monette Ribeyrol. "), _c('em', [_vm._v("Livres & Légendes Bogomiles")]), _vm._v(". Paris: G.-P. Maisonneuve et Larose, 1976.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Novaković, Stojan. “Apokrif o prepiranju Isusa Hrista sa djavolom.” "), _c('em', [_vm._v("Starine")]), _vm._v(" 16 (1884): 86–89. (Edition of Church Slavic H.)")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Petkanova, Donka. "), _c('em', [_vm._v("Stara b")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǎ")]), _c('em', [_vm._v("lgarska literatura. Apokrifi")]), _vm._v(". Sofia: B"), _c('span', {
    staticClass: "special-char"
  }, [_vm._v("ǎ")]), _vm._v("lgarski pisatel, 1981. (Translation of Church Slavic D, 173–76.)")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Polivka, Georg Jiří. “Opisi i izvodi iz nekoliko jugoslavenskih rukopisa u Pragu.” "), _c('em', [_vm._v("Starine")]), _vm._v(" 22 (1890): 200–203. (Edition of Church Slavic I.)")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Pypin, Alexander N. "), _c('em', [_vm._v("Ložnyja i otrečennyja knigi russkoj stariny")]), _vm._v(". Pamjatniki starinnoj russkoj literatury 3. Saint Petersburg: Tipografîja P. A. Kuliša, 1862. ("), _c('em', [_vm._v("Editio princeps")]), _vm._v(" based on Church Slavic J2, pp. 86–88.)")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Radčenko, Konstantin F. “Zametki o pergamennom sbornike No. 139 (137) XIV veka Venskoj Pridvornoj biblioteki.” "), _c('em', [_vm._v("IORJAS")]), _vm._v(" 12, no. 3 (1907): 196–98. (Edition of Church Slavic B.)")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Sambunjak, Slavomir. "), _c('em', [_vm._v("Jezik i stil hrvatskih glagoljskih prenja")]), _vm._v(". Split: Književni Krug, 2000. (Edition of the five Croatian Glagolitic manuscripts, pp. 228–37.)")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Strohal, Rudolf. "), _c('em', [_vm._v("Stare hrvatske apokrifne priče i legendi. Sabrao iz starih hrvatskih glagolskih rukopisa od 14–18 vijeka Rudolf Strohal")]), _vm._v(". Bjelovar: Tisak i naklada Lav. Weiss-a, 1917."), _c('em'), _vm._v(" (Edition of Church Slavic K2, pp. 54–56.)")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Tichonravov, Nikolai S. "), _c('em', [_vm._v("Pamjatniki otrečennoj russkoj literatury.")]), _vm._v(" 2 vols. Moscow: Obščestv. Pol"), _c('span', {
    staticClass: "special-char"
  }, [_vm._v("ǐ")]), _vm._v("za, 1863. (Edition of Church Slavic J2 and M, 2:282–88.)")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Vassiliev, Athanasius. "), _c('em', [_vm._v("Anecdota graeco-byzantina, pars prior.")]), _vm._v(" Moscow: Imperial University, 1893. ("), _c('em', [_vm._v("Editiones princeps")]), _vm._v(" of Greek M and V, pp. 4–10.)")]), _vm._v(" "), _c('p', {
    staticClass: "bib-h2"
  }, [_vm._v("STUDIES")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Berger, Klaus. "), _c('em', [_vm._v("Die griechische Daniel-Diegese: eine altkirchliche Apokalypse: Text, Übersetzung und Kommentar.")]), _vm._v(" Leiden: Brill, 1976.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Fuchs, Albert. "), _c('em', [_vm._v("Konkordanz zu Gespräch Jesu mit dem Teufel, Version A und B.")]), _vm._v(" Linz: Fuchs, 1983.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Geller, Florentina Badalanova. “"), _c('em', [_vm._v("The Sea of Tiberias")]), _vm._v(":"), _c('em'), _vm._v(" Between Apocryphal Literature and Oral Tradition.” Pages 13–157 in "), _c('em', [_vm._v("The Old Testament Apocrypha in the Slavonic Tradition.")]), _vm._v(" Edited by Lorenzo DiTommaso and Christfried Böttrich. TSAJ 140. Tübingen: Mohr Siebeck, 2011.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. “Slavonic Redactions of the Apocryphal "), _c('em', [_vm._v("Homily of John Chrysostom on How Archangel Michael Defeated Satanail")]), _vm._v(": Some Considerations.” Pages 96–131 in "), _c('em', [_vm._v("The Embroidered Bible: Studies in Biblical Apocrypha and Pseudepigrapha in Honour of Michael E. Stone")]), _vm._v(". Edited by Lorenzo DiTommaso, Matthias Henze, and William Adler. Leiden: Brill, 2018. (See esp. pp. 103–4, which include an excerpt from Sofia, Narodna Biblioteka, 433.)")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Harris, J. Rendel. "), _c('em', [_vm._v("The Rest of the Words of Baruch: A Christian Apocalypse of the Year 136 A. D.; The Text Revised with an Introduction.")]), _vm._v(" Cambridge: Cambridge University Press, 1889. (Detailed description of Greek J, but incomplete and using old folio numbering, pp. 27–29.)")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("McGinn, Bernard. "), _c('em', [_vm._v("Antichrist: Two Thousand Years of the Human Fascination with Evil")]), _vm._v(". New York: Columbia University Press, 2000.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Miltenov, Yavor. “Apocryphal Apocalypse of John the Theologian: Analysis of Intertextual Relations.” "), _c('em', [_vm._v("Palaeobulgarica")]), _vm._v(" 28, no. 3 (2004): 85–102.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Miltenova, Anissava. “Slavonic Apocrypha: New Discoveries, New Perusals: The Cases of the Dispute between Our Lord Jesus Christ and the Antichrist and the Story about Beautiful Joseph.” "), _c('em', [_vm._v("Scrinium")]), _vm._v(" 14, no. 1 (2018): 273–88. (Revised list of Church Slavic MSS, pp. 273–82.)")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. “Za Sinajskija prepis na ‘Prenie na Iisus Christos s djavola’ i negovija kontekst.” Pages 21–33 in "), _c('em', [_vm._v("“Slova i zolota vjaz")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǐ")]), _vm._v(" "), _c('em', [_vm._v("…” Sbornik statej pamjati Vjačeslava Michajloviča Zagrebina (1942–2004)")]), _vm._v(". Edited by Z. L. Levšina. Saint Petersburg: Izdatel"), _c('span', {
    staticClass: "special-char"
  }, [_vm._v("ǐ")]), _vm._v("stvo Rossijskaja nacional"), _c('span', {
    staticClass: "special-char"
  }, [_vm._v("ǐ")]), _vm._v("naja biblioteka, 2016.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Petkov, Julian. "), _c('em', [_vm._v("Altslavische Eschatologie: Texte und Studien zur apokalyptischen Literatur in kirchenslavischer Überlieferung.")]), _vm._v(" TANZ 59. Tübingen: Narr Francke Attempto, 2016.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Radčenko, Konstantin. “Etjudy po bogomil"), _c('span', {
    staticClass: "special-char"
  }, [_vm._v("ǐ")]), _vm._v("stvu.” Pages 29–38 in "), _c('em', [_vm._v("Izbornik Kievskij posvjaščennyj T. D. Florinskomu")]), _vm._v(". Kyiv: Tip. T. G. Mejnandera, P. A Barskogo, I. I. Čokolova i Kievo-Pečersk. lavry, 1904.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Rosenstiehl, Jean-Marc. “Armenian Witnesses of Three Eschatological Motifs.” Pages 254–82 in "), _c('em', [_vm._v("The Armenian Apocalyptic Tradition: A Comparative Perspective.")]), _vm._v(" Edited by Kevork B. Bardakjian and Sergio La Porta. Leiden: Brill, 2014.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Turdeanu, Émil. “Apocryphes bogomiles et apocryphes pseudo-bogomiles.” "), _c('em', [_vm._v("RHR")]), _vm._v(" 138 (1950): 22–52, 176–218.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Vliet, Jacques van der. “Une Vierge de Daphné: Notes sur un Thème Apocalyptique.” "), _c('em', [_vm._v("Byzantion")]), _vm._v(" 64, no. 2 (1994): 377–90.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/foot.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_001",
      "id": "foot-001"
    }
  }, [_vm._v("1")]), _vm._v(". See Averil Cameron, "), _c('em', [_vm._v("Dialoguing in Late Antiquity")]), _vm._v(" (Cambridge, MA: Center for Hellenic Studies, 2014), on how “these prose dialogues—literary discussions between two or more speakers on a specific question or group of related questions—are still neglected as a significant component of late antique Christian literature. This is still more the case for Byzantium, even though dialogues continued to be written in Greek for many centuries and were particularly favored by Byzantine intellectuals in some periods” (1). While this text was unknown in Anglo-American circles until recently, the dialogic form surrounding the characters of Jesus and the devil was well known in a nineteenth-century American schoolbook, "), _c('em', [_vm._v("A Dialogue between Christ, a Youth, and the Devil")]), _vm._v(" (Philadelphia: American Sunday-School Union, 1846).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_002",
      "id": "foot-002"
    }
  }, [_vm._v("2")]), _vm._v(". While the temptation of Christ is well known and used by early Christian writers, there are few narrative expansions or rereadings of this gospel scene. One other example may be found in the "), _c('em', [_vm._v("Book of Allogenes")]), _vm._v(" (Tchacos Codex, IV), in which Allogenes ascends Mount Tabor and is tempted by Satan twice before his transfiguration. See Madeleine Scopello, “The Temptation of Allogenes (Codex Tchacos, Tractate IV),” in "), _c('em', [_vm._v("Gnosticism, Platonism and the Late Ancient World: Essays in Honor of John D. Turner")]), _vm._v(","), _c('em'), _vm._v(" ed. Kevin Corrigan and Tuomas Rasimus, Nag Hammadi and Manichaean Studies 82 (Leiden: Brill, 2013), 117–37.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_003",
      "id": "foot-003"
    }
  }, [_vm._v("3")]), _vm._v(". Vassiliev, "), _c('em', [_vm._v("Anecdota graeco-byzantina")]), _vm._v(", 4–10.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_004",
      "id": "foot-004"
    }
  }, [_vm._v("4")]), _vm._v(". Casey and Thomson, “Dialogue,” 49–65.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_005",
      "id": "foot-005"
    }
  }, [_vm._v("5")]), _vm._v(". Tichonravov, "), _c('em', [_vm._v("Pamjatniki")]), _vm._v(","), _c('em'), _vm._v(" 2:282–88; see Casey and Thomson, “Dialogue,” 49.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_006",
      "id": "foot-006"
    }
  }, [_vm._v("6")]), _vm._v(". Before the addition of Arabic numerals to the manuscript, the Greek numbers for these folia read—as Rendel Harris recorded—from 182 ("), _c('span', {
    staticClass: "overline-3a"
  }, [_vm._v("ρπβ")]), _vm._v(") to 186 ("), _c('span', {
    staticClass: "overline-3a"
  }, [_vm._v("ρπς")]), _vm._v("). At some point in the twentieth century, these Greek numbers were struck through.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_007",
      "id": "foot-007"
    }
  }, [_vm._v("7")]), _vm._v(". Harris, "), _c('em', [_vm._v("Rest of the Words of Baruch")]), _vm._v(", 27–29; Casey and Thomson, “Dialogue,” 49. For more on this manuscript, see Albert Ehrhard, "), _c('em', [_vm._v("Überlieferung und Bestand der hagiographischen und homiletischen Literatur der griechischen Kirche von den Anfängen bis zum Ende des 16. Jahrhunderts")]), _vm._v(","), _c('em'), _vm._v(" TU 50–52, 3 vols. (Leipzig: Hinrichs, 1937–1952), 3:845; Athanasios Papadopoulos-Kérameus, "), _c('em', [_vm._v("Hierosolumitikē bibliothēkē ētoi katalogos tōn en tais bibliothēkais tou hagiōtatou apostolikou")]), _vm._v(", 3 vols. (1894; repr. Brussels: Culture et Civilization, 1963), 1:149–54.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_008",
      "id": "foot-008"
    }
  }, [_vm._v("8")]), _vm._v(". Casey and Thomson, “Dialogue,” 64.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_009",
      "id": "foot-009"
    }
  }, [_vm._v("9")]), _vm._v(". As the traditional terms “Slavonic” and “Slavic” are ambiguous, in what follows we will be referring to these recensions by their language of composition, which is Church Slavic.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_010",
      "id": "foot-010"
    }
  }, [_vm._v("10")]), _vm._v(". De Santos Otero, "), _c('em', [_vm._v("HUAA")]), _vm._v(", 2:156–60.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_011",
      "id": "foot-011"
    }
  }, [_vm._v("11")]), _vm._v(". Francis J. Thomson, “Apocrypha Slavica: II,” review of "), _c('em', [_vm._v("HUAA")]), _vm._v(" 2, by Aurelio de Santos Otero, "), _c('em', [_vm._v("Slavonic and East European Review")]), _vm._v(" 63.1 (1985): 79–98, esp. 88–89.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_012",
      "id": "foot-012"
    }
  }, [_vm._v("12")]), _vm._v(". Petkov, "), _c('em', [_vm._v("Altslavische Eschatologie")]), _vm._v(", 163–65.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_013",
      "id": "foot-013"
    }
  }, [_vm._v("13")]), _vm._v(". Miltenova, “Slavonic Apocrypha,” 276–77.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_014",
      "id": "foot-014"
    }
  }, [_vm._v("14")]), _vm._v(". Edition in Franko, "), _c('em', [_vm._v("Apokrifi î legendi")]), _vm._v(", 2:200–203.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_015",
      "id": "foot-015"
    }
  }, [_vm._v("15")]), _vm._v(". Pypin, "), _c('em', [_vm._v("Ložnyja")]), _vm._v(","), _c('em'), _vm._v(" 86–88.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_016",
      "id": "foot-016"
    }
  }, [_vm._v("16")]), _vm._v(". Tichonravov, "), _c('em', [_vm._v("Pamjatniki")]), _vm._v(", 2:285–88.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_017",
      "id": "foot-017"
    }
  }, [_vm._v("17")]), _vm._v(". Casey and Thomson, “Dialogue.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_018",
      "id": "foot-018"
    }
  }, [_vm._v("18")]), _vm._v(". Edition in Franko, "), _c('em', [_vm._v("Apokrifi î legendi")]), _vm._v(", 2:200–203.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_019",
      "id": "foot-019"
    }
  }, [_vm._v("19")]), _vm._v(". Probably Dubove, in today’s Tjačiv region of the Ukraine. The actual provenance of the manuscript is unclear.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_020",
      "id": "foot-020"
    }
  }, [_vm._v("20")]), _vm._v(". Franko, "), _c('em', [_vm._v("Apokrifi î legendi")]), _vm._v(", 2:196–200.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_021",
      "id": "foot-021"
    }
  }, [_vm._v("21")]), _vm._v(". Franko, "), _c('em', [_vm._v("Apokrifi î legendi")]), _vm._v(", 2:199.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_022",
      "id": "foot-022"
    }
  }, [_vm._v("22")]), _vm._v(". Franko, "), _c('em', [_vm._v("Apokrifi î legendi")]), _vm._v(", 2:200–203.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_023",
      "id": "foot-023"
    }
  }, [_vm._v("23")]), _vm._v(". Miltenova, “Za Sinajskija prepis,” 21–33.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_024",
      "id": "foot-024"
    }
  }, [_vm._v("24")]), _vm._v(". Radčenko, “Zametki,” 196–98; Ivanov, "), _c('em', [_vm._v("Bogomilski knigi i legendi")]), _vm._v(", 249–53.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_025",
      "id": "foot-025"
    }
  }, [_vm._v("25")]), _vm._v(". Edition in Ivanov, "), _c('em', [_vm._v("Bogomilski knigi i legendi")]), _vm._v(", 249–53; Petkanova, "), _c('em', [_vm._v("Stara b")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǎ")]), _c('em', [_vm._v("lgarska literatura")]), _vm._v(", 173–76.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_026",
      "id": "foot-026"
    }
  }, [_vm._v("26")]), _vm._v(". Novaković, “Apokrif,” 86–89.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_027",
      "id": "foot-027"
    }
  }, [_vm._v("27")]), _vm._v(". Polívka, “Opisi,” 200–203.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_028",
      "id": "foot-028"
    }
  }, [_vm._v("28")]), _vm._v(". Miltenova, “Slavonic Apocrypha,” 279–81.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_029",
      "id": "foot-029"
    }
  }, [_vm._v("29")]), _vm._v(". Nicolina Trunte, "), _c('em', [_vm._v("Slavenskïj ęzyk")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǔ")]), _c('em', [_vm._v(": Ein praktisches Lehrbuch des Kirchenslavischen in 30 Lektionen, zugleich eine Einführung in die slavische Philologie")]), _vm._v(","), _c('em'), _vm._v(" vol. 2, "), _c('em', [_vm._v("Mittel- und Neukirchenslavisch")]), _vm._v(" (Munich: Sagner, 2014), 38.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_030",
      "id": "foot-030"
    }
  }, [_vm._v("30")]), _vm._v(". Biserka Grabar, “Apokrifna djela apostolska u hrvatskoglagoljskoj literaturi. 1. Djela Andrije i mateja u gradu ljudoždera. 2. Djela apostola Petra i Andrije.” "), _c('em', [_vm._v("Radovi Staroslavenskog instituta")]), _vm._v(" 6 (1967): 109–208 at 119.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_031",
      "id": "foot-031"
    }
  }, [_vm._v("31")]), _vm._v(". Grabar, “Apokrifna djela apostolska,” 120–21.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_032",
      "id": "foot-032"
    }
  }, [_vm._v("32")]), _vm._v(". Sambunjak, "), _c('em', [_vm._v("Jezik")]), _vm._v(", 228–37. K2 appeared previously in Strohal, "), _c('em', [_vm._v("Stare hrvatske apokrifne")]), _vm._v(", 54–56.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_033",
      "id": "foot-033"
    }
  }, [_vm._v("33")]), _vm._v(". Marija-Ana Dürrigl and Stella Fatović-Ferencić, “Introducing Death: A 15th Century Croatian Glagolitic Literary Text,” "), _c('em', [_vm._v("Croatian Medical Journal")]), _vm._v(" 42 (2001): 683–88.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_034",
      "id": "foot-034"
    }
  }, [_vm._v("34")]), _vm._v(". Sambunjak, "), _c('em', [_vm._v("Jezik")]), _vm._v(", 15.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_035",
      "id": "foot-035"
    }
  }, [_vm._v("35")]), _vm._v(". Sambunjak, "), _c('em', [_vm._v("Jezik")]), _vm._v(", 92.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_036",
      "id": "foot-036"
    }
  }, [_vm._v("36")]), _vm._v(". Jiří Dynda, "), _c('em', [_vm._v("Slovanské pohanství ve středověkých ruských kázáních")]), _vm._v(" (Prague: Scriptorium, 2019), 345–56.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_037",
      "id": "foot-037"
    }
  }, [_vm._v("37")]), _vm._v(". Dynda, "), _c('em', [_vm._v("Slovanské")]), _vm._v(", 156–57.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_038",
      "id": "foot-038"
    }
  }, [_vm._v("38")]), _vm._v(". Péter Tóth, “New Wine in Old Wineskin: Byzantine Reuses of the Apocryphal Revelation Dialogue,” in "), _c('em', [_vm._v("Dialogues and Debates from Late Antiquity to Late Byzantium")]), _vm._v(", ed. Averil Cameron and Niels Gaul (New York: Routledge, 2017), 77–93.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_039",
      "id": "foot-039"
    }
  }, [_vm._v("39")]), _vm._v(". The following discussion focuses on the Greek version of the text; accordingly, the accompanying citations follow the numbering of the Greek text.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_040",
      "id": "foot-040"
    }
  }, [_vm._v("40")]), _vm._v(". See Wilhelm Bousset, "), _c('em', [_vm._v("The Antichrist Legend: A Chapter in Christian and Jewish Folklore")]), _vm._v(", trans. August Henry Keane (London: Hutchinson, 1896), 138–45, on the conflation (and patristic pushback against conflation) of the devil and the antichrist in early Christian literature, as well as how the antichrist will become incarnate as well. "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" thus stands in contrast to other late ancient texts, such as Oecumenius, "), _c('em', [_vm._v("Comm. Apoc.")]), _vm._v(" 8.3,"), _c('em'), _vm._v(" that take particular pains to distinguish the antichrist from the devil. On the prevalence of dialogical narratives regarding Satan’s role as an enemy of God, his desire for God’s throne, and his inevitable end, see Mohammad Zarasi, Abdollatif Ahmadi Ramchahi, and Iman Kanani, “Satan in Dialogue with God: A Comparative Study between Islam, Judaism, Christianity, and Zoroastrianism,” "), _c('em', [_vm._v("Al-Bayan")]), _vm._v(" 13 (2015): 197–222.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_041",
      "id": "foot-041"
    }
  }, [_vm._v("41")]), _vm._v(". For more on the devil’s association with spit and God’s association with breath, see Florentina Badalanova Geller, “"), _c('em', [_vm._v("The Sea of Tiberias:")]), _vm._v(" Between Apocryphal Literature and Oral Tradition,” in "), _c('em', [_vm._v("The Old Testament Apocrypha in the Slavonic Tradition")]), _vm._v(","), _c('em'), _vm._v(" ed. Lorenzo DiTommaso and Christfried Böttrich, Texts and Studies in Ancient Judaism 140 (Tübingen: Mohr Siebeck, 2011), 42–44. Geller notes that in later Russian redactions of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(", the narrative blends at certain points with a Church Slavic text known as the "), _c('em', [_vm._v("Sea of Tiberias.")]), _vm._v(" She argues that "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(", "), _c('em', [_vm._v("Sea of Tiberias")]), _vm._v(","), _c('em'), _vm._v(" and "), _c('em', [_vm._v("3 Baruch")]), _vm._v(" all share an Ur-text that tie together their narrative of Satan’s refusal to worship Adam—a narrative present in Latin, Armenian, and Georgian recensions of the "), _c('em', [_vm._v("Life of Adam and Eve")]), _vm._v(" but not in Greek and Church Slavic recensions"), _c('em'), _vm._v(" (ibid., 81–84).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_042",
      "id": "foot-042"
    }
  }, [_vm._v("42")]), _vm._v(". It is worth noting that this tradition is extant in the Latin, Georgian, and Armenian versions of "), _c('em', [_vm._v("LAE")]), _vm._v(" but not in the Greek. See Gary A. Anderson and Michael E. Stone, eds., "), _c('em', [_vm._v("A Synopsis of the Books of Adam and Eve")]), _vm._v(", 2nd rev. ed., SBLEJL 17 (Atlanta: Scholars, 1999).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_043",
      "id": "foot-043"
    }
  }, [_vm._v("43")]), _vm._v(". Q 2:34–36; 7:11–22; 15:29–31; 17:61–64; 18:50; 20:116–22; 38:72–88. Also see "), _c('em', [_vm._v("Fī ta"), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ṯ")]), _vm._v("lī"), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ṯ")]), _vm._v(" Allāh al-wā"), _c('span', {
    staticClass: "chr"
  }, [_vm._v("ḥ")]), _vm._v("id")]), _vm._v(" (Sinai ar. 154) in Samir Khalil Samir, “The Earliest Arab Apology for Christianity (c. 750),” in "), _c('em', [_vm._v("Christian Arabic Apologetics During the Abbasid Period (750–1258)")]), _vm._v(", ed. Samir Khalil Samir and Jørgen S. Nielsen, Numen 63 (Leiden: Brill, 1994), 57–113. Much like the Qur’anic tradition, Eve is not mentioned in this recounting of Adam’s disobedience in the garden of Eden; rather, blame is placed upon the devil. See Mohammed Mahmoud, “The Story of Creation and Disobedience in the Quran: The Absence of Eve and the Centrality of Satan,” "), _c('em', [_vm._v("Alif: Journal of Comparative Poetics")]), _vm._v(" 19"), _c('em'), _vm._v(" (1999): 66–95.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_044",
      "id": "foot-044"
    }
  }, [_vm._v("44")]), _vm._v(". On these texts, see the translations by Alin Suciu ("), _c('em', [_vm._v("MNTA")]), _vm._v(" 1:526–45), Lance Jenott ("), _c('em', [_vm._v("MNTA")]), _vm._v(" 2:559–79), and Hugo Lundhaug ("), _c('em', [_vm._v("MNTA")]), _vm._v(" 2:499–522). Also see P. Bala"), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ʾ")]), _vm._v("izah 27, a portion of a dialogue in Coptic between Jesus and the disciples regarding the fall of the devil. Edition and translation in Paul E. Kahle, "), _c('em', [_vm._v("Bala"), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ʾ")]), _vm._v("izah: Coptic Texts from Deir El-Bala"), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ʾ")]), _vm._v("izah in Upper Egypt")]), _vm._v(", 2 vols. (London: Oxford University Press, 1954), 1:403–4.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_045",
      "id": "foot-045"
    }
  }, [_vm._v("45")]), _vm._v(". For more, see Savas Agourides, “Apocalypse of Sedrach (Second to Fifth Century A. D.),” in "), _c('em', [_vm._v("The Old Testament Pseudepigrapha")]), _vm._v(","), _c('em'), _vm._v(" 2 vols., ed. James H. Charlesworth, ABRL (New York: Doubleday, 1983–1985), 1:604–13.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_046",
      "id": "foot-046"
    }
  }, [_vm._v("46")]), _vm._v(". Such traditions of Satan’s attempt to establish a throne and his jealousy of Adam also appear in other Latin and Church Slavic texts, such as the "), _c('em', [_vm._v("Homily of John Chrysostom on How Archangel Michael Defeated Satanail")]), _vm._v(", "), _c('em', [_vm._v("2 Enoch")]), _vm._v(", "), _c('em', [_vm._v("Quest. John")]), _vm._v(", "), _c('em', [_vm._v("3 Baruch")]), _vm._v(","), _c('em'), _vm._v(" and "), _c('em', [_vm._v("Legend of the Sea of Tiberias.")]), _vm._v(" See Geller, “Slavonic Redactions,” esp. 96–105.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_047",
      "id": "foot-047"
    }
  }, [_vm._v("47")]), _vm._v(". See Roger T. Beckwith, "), _c('em', [_vm._v("Calendar and Chronology, Jewish and Christian: Biblical, Intertestamental and Patristic Studies")]), _vm._v(" (Leiden: Brill, 1996), 297–309; Robert Hall, “Disjunction of Heavenly and Earthly Times in the "), _c('em', [_vm._v("Ascension of Isaiah")]), _vm._v(",” "), _c('em', [_vm._v("JSJ")]), _vm._v(" 35.1 (2004): 17–26. Also see Ps.-Hippolytus, "), _c('em', [_vm._v("Antichr.")]), _vm._v(" 43:2, on Enoch and Elijah proclaiming repentance to all the nations during these three and a half years.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_048",
      "id": "foot-048"
    }
  }, [_vm._v("48")]), _vm._v(". Also see Adso of Montier-en-Der’s "), _c('em', [_vm._v("De ortu et tempore Antichristi")]), _vm._v(" (in Bernard McGinn, ed., "), _c('em', [_vm._v("Apocalyptic Spirituality: Treatises and Letters of Lactantius, Adso of Moniet-en-Der, Joachim of Fiore, The Franciscan Spirituals, Savonarola")]), _vm._v(" [New York: Paulist, 1979], 94–96), where Enoch and Elijah return to earth and prepare the elect for battle for three and a half years before the antichrist kills them (cf. Rev 11:7). By the second century, Enoch and Elijah are associated with the antichrist as the prophetic figures that reveal his identity and false wonders; see "), _c('em', [_vm._v("Apoc. Pet.")]), _vm._v(" (Eth.) 2:7–13.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_049",
      "id": "foot-049"
    }
  }, [_vm._v("49")]), _vm._v(". See David Cook, “Early Islamic and Classical Sunni and Shi’ite Apocalyptic Movements,” in "), _c('em', [_vm._v("The Oxford Handbook of Millennialism")]), _vm._v(","), _c('em'), _vm._v(" ed. Catherine Wessinger (Oxford: Oxford University Press, 2011), 267–83 at 267–69. Also see the Old Nubian "), _c('em', [_vm._v("Attiri Book of Michael")]), _vm._v(" (P. Attiri 1–2) regarding Michael’s role in the resurrection and regarding the devil’s stand against the other angels; text and translation in Vincent W. J. van Gerven Oei et al., "), _c('em', [_vm._v("The Old Nubian Texts from Attiri")]), _vm._v(", Dotawo Monographs 1 (Santa Barbara: Punctum Books, 2016), 30–54.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_050",
      "id": "foot-050"
    }
  }, [_vm._v("50")]), _vm._v(". See the translation by Rick Brannan in "), _c('em', [_vm._v("MNTA")]), _vm._v(" 2:378–98.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_051",
      "id": "foot-051"
    }
  }, [_vm._v("51")]), _vm._v(". Miltenov, “Apocryphal Apocalypse of John,” 89–90.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_052",
      "id": "foot-052"
    }
  }, [_vm._v("52")]), _vm._v(". See Robert Casey, “The Apocalypse of Paul,” "), _c('em', [_vm._v("JTS")]), _vm._v(" 34 (1933): 1–32, esp. 11–12.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_053",
      "id": "foot-053"
    }
  }, [_vm._v("53")]), _vm._v(". For more on this reference to fish and the various types of fish it might be, see van der Vliet, “Une Vierge de Daphné,” esp. 380–82; Berger, "), _c('em', [_vm._v("Die griechische Daniel-Diegese")]), _vm._v(", 110; McGinn, "), _c('em', [_vm._v("Antichrist")]), _vm._v(","), _c('em'), _vm._v(" 95–96. Also see the much earlier reference to a virgin handling a fish in the Abercius Inscription. See Goffredo Zaccherinin, "), _c('em', [_vm._v("L’iscrizione di Abercio")]), _vm._v(" (Rome: dal Bessarione, 1898), 3–4.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_054",
      "id": "foot-054"
    }
  }, [_vm._v("54")]), _vm._v(". Casey and Thomson, “Dialogue,” 63.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_055",
      "id": "foot-055"
    }
  }, [_vm._v("55")]), _vm._v(". Van der Vliet, “Vierge de Daphné,” 383–85.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_056",
      "id": "foot-056"
    }
  }, [_vm._v("56")]), _vm._v(". Berger, "), _c('em', [_vm._v("Die griechische Daniel-Diegese")]), _vm._v(","), _c('em'), _vm._v(" 106–7.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_057",
      "id": "foot-057"
    }
  }, [_vm._v("57")]), _vm._v(". In "), _c('em', [_vm._v("Apoc. Ps.-Meth.")]), _vm._v(" 9:8–9 and 14:5,"), _c('em'), _vm._v(" the offspring of Chouseth are meant to be eternal and unconquerable Christian rulers until passing their reign to Christ at the appearance of the antichrist (cf. Ps 67:32).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_058",
      "id": "foot-058"
    }
  }, [_vm._v("58")]), _vm._v(". David Frankfurter, "), _c('em', [_vm._v("Christianizing Egypt: Syncretism and Local Worlds in Late Antiquity")]), _vm._v(" (Princeton, NJ: Princeton University Press, 2018), 212–18, quotation at 212.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_059",
      "id": "foot-059"
    }
  }, [_vm._v("59")]), _vm._v(". See van der Vliet, “Vierge de Daphné,” 387.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_060",
      "id": "foot-060"
    }
  }, [_vm._v("60")]), _vm._v(". See Bousset, "), _c('em', [_vm._v("Antichrist Legend")]), _vm._v(","), _c('em'), _vm._v(" 140–41; and Marco Rizzi, “L’ombra dell’anticristo nel cristianesimo orientale tra tarda antichità e prima età bizantina,” in "), _c('em', [_vm._v("Antichrist: Konstruktionen von Feindbildern")]), _vm._v(","), _c('em'), _vm._v(" ed. Wolfram Brandes and Felicitas Schmieder (Berlin: Akademie, 2010), 4–5, on Ps.-Hippolytus, "), _c('em', [_vm._v("De consummatione mundi")]), _vm._v(","), _c('em'), _vm._v(" which contains this tradition of the antichrist being born of a virgin. See also McGinn, "), _c('em', [_vm._v("Apocalyptic Spirituality")]), _vm._v(","), _c('em'), _vm._v(" 90–91, for Adso’s treatment of the antichrist’s virgin birth, which he suggests will take place in Babylon, after which the antichrist will be raised in Bethsaida and Corozain. As Alice Whealey notes, "), _c('em', [_vm._v("De consummatione mundi")]), _vm._v(" is a Byzantine redaction of the third-century Hippolytan "), _c('em', [_vm._v("Antichr.")]), _vm._v(" See Whealey, “"), _c('em', [_vm._v("De consummatione mundi")]), _vm._v(" of Pseudo-Hippolytus: Another Byzantine Apocalypse from the Early Islamic Period,” "), _c('em', [_vm._v("Byzantion")]), _vm._v(" 66 (1996): 461–69.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_061",
      "id": "foot-061"
    }
  }, [_vm._v("61")]), _vm._v(". See James H. Srawley, "), _c('em', [_vm._v("The Catechetical Oration of Gregory of Nyssa")]), _vm._v(" (Cambridge: Cambridge University Press, 1903), 92–93 (§24); Ernest Gebhardt, "), _c('em', [_vm._v("On the Three-Day Period between the Death and Resurrection of Christ")]), _vm._v(" (Leiden: Brill, 1967), 280–81; Nicholas P. Constas, “The Last Temptation of Satan: Divine Deception in Greek Patristic Interpretations of the Passion Narrative,” "), _c('em', [_vm._v("HTR")]), _vm._v(" 97.2 (2004): 139–63, esp. 143–49. Constas notes that, while modern scholarship generally abhors Gregory of Nyssa’s understanding of divine deception here, this motif is carried on by the likes of Athanasius, John Chrysostom, John of Damascus, and Maximus the Confessor, among others.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_062",
      "id": "foot-062"
    }
  }, [_vm._v("62")]), _vm._v(". See Berger, "), _c('em', [_vm._v("Die griechische Daniel-Diegese")]), _vm._v(","), _c('em'), _vm._v(" 105–6; van der Vliet, “Vierge de Daphné,” 388–90. However, we do have Procopius presenting Justinian as the antichrist in his "), _c('em', [_vm._v("Anecdota")]), _vm._v(","), _c('em'), _vm._v(" demonstrating that Christian figures were open to such interpretive, apocalyptic scrutiny. See McGinn, "), _c('em', [_vm._v("Antichrist")]), _vm._v(", 83–84.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_063",
      "id": "foot-063"
    }
  }, [_vm._v("63")]), _vm._v(". Radčenko, “Etjudy po bogomil"), _c('span', {
    staticClass: "special-char"
  }, [_vm._v("ǐ")]), _vm._v("stvu,” 38. For more on the Bogomils, see Steven Runciman, "), _c('em', [_vm._v("The Medieval Manichee: A Study of the Christian Dualist Heresy")]), _vm._v(" (Cambridge: Cambridge University Press, 1982), 63–93; Dimitri Obolensky, "), _c('em', [_vm._v("The Bogomils: A Study in Balkan Neo-Manichaeism")]), _vm._v(" (New York: AMS, 1978).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_064",
      "id": "foot-064"
    }
  }, [_vm._v("64")]), _vm._v(". Turdeanu, “Apocryphes bogomiles,” 194–99.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_065",
      "id": "foot-065"
    }
  }, [_vm._v("65")]), _vm._v(". Vassiliev, "), _c('em', [_vm._v("Anecdota graeco-byzantina")]), _vm._v(","), _c('em'), _vm._v(" vi.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_066",
      "id": "foot-066"
    }
  }, [_vm._v("66")]), _vm._v(". See Charles D. Wright, "), _c('em', [_vm._v("MNTA")]), _vm._v(" 1:486; McGinn, "), _c('em', [_vm._v("Antichrist")]), _vm._v(","), _c('em'), _vm._v(" 87–88, 100–103. For a translation of Adso’s treatise to Queen Gerberga, see McGinn, "), _c('em', [_vm._v("Apocalyptic Spirituality")]), _vm._v(", 89–96. Also see Ps.-Hippolytus, "), _c('em', [_vm._v("De consummatione mundi")]), _vm._v("; Ps.-Hippolytus, "), _c('em', [_vm._v("Antichr.")]), _vm._v(" 15:1; "), _c('em', [_vm._v("Apoc. Ps.-Meth.")]), _vm._v(" 14:1, 6; and "), _c('em', [_vm._v("Tib. Sib.")]), _vm._v(" 8:3 regarding the tradition of the antichrist being a Jew arising from the tribe of Dan (Gen 49:17). On the antichrist being born from a whore in Chorazin, also see "), _c('em', [_vm._v("2 Revelation of Matthew about the End Times")]), _vm._v(" in this volume.")]), _vm._v(" "), _c('p', {
    staticClass: "ch-titlep"
  }, [_vm._v("The Dialogue between Jesus and the Devil")]), _vm._v(" "), _c('div', {
    staticClass: "inside"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td50"
  }, [_c('p', {
    staticClass: "t-head"
  }, [_vm._v("GREEK")])]), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "t-head"
  }, [_vm._v("CHURCH SLAVIC")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td50"
  }, [_c('p', {
    staticClass: "t-h1"
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "para"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td50"
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Narration of the dispute of the devil with our Lord Jesus Christ."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-067",
      "id": "foot_067"
    }
  }, [_vm._v("a")])]), _vm._v(" Father bless.")])]), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("On the dispute between the devil and our Lord. Bless, Lord Father.")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Dispute over Jesus’s origin")]), _vm._v(" "), _c('div', {
    staticClass: "inside"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td50"
  }, [_c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "chap-num"
  }, [_vm._v("1")]), _vm._v(" "), _c('sup', [_vm._v("1")]), _vm._v("When Jesus Christ, our Lord, came to the mountain with Peter, James, Andrew, and John"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-068",
      "id": "foot_068"
    }
  }, [_vm._v("b")])]), _vm._v(" and the rest of his holy"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-069",
      "id": "foot_069"
    }
  }, [_vm._v("c")])]), _vm._v(" disciples, "), _c('sup', [_vm._v("2")]), _vm._v("Jesus"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-070",
      "id": "foot_070"
    }
  }, [_vm._v("d")])]), _vm._v(" fasted for forty days. "), _c('sup', [_vm._v("3")]), _vm._v("The devil appeared before him and said to him, “Ι swear an oath with you in the name of mighty God, yes!, that you tell me the entire truth."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-071",
      "id": "foot_071"
    }
  }, [_vm._v("e")])]), _vm._v(" Where are you from?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("4")]), _vm._v("Jesus said to him, “I am from the eternal and immortal God.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("5")]), _vm._v("The devil said to him, “You say so."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-072",
      "id": "foot_072"
    }
  }, [_vm._v("f")])]), _vm._v(" Go to heaven and sit on your throne, so that the heavens which you fabricated"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-073",
      "id": "foot_073"
    }
  }, [_vm._v("g")])]), _vm._v(" and the earth, as you say, may be at rest in you. You have angels. Why did you not send them? Instead you, being God, came along such a path.”")])]), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "chap-num"
  }, [_vm._v("1")]), _vm._v(" "), _c('sup', [_vm._v("1")]), _vm._v("When Jesus came to the Mount of Olives, he said to his disciples, “We will fast here for forty days to contend with the devil.” "), _c('sup', [_vm._v("2")]), _vm._v("The disciples then fasted with Jesus. "), _c('sup', [_vm._v("3")]), _vm._v("When the devil heard that Jesus was fasting against him, he was enraged"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-077",
      "id": "foot_077"
    }
  }, [_vm._v("a")])]), _vm._v(" and appeared before the Lord.")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Mark 9:2 par.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("4")]), _vm._v("And Jesus said, “I adjure you, devil, by the living God, to tell me: where are you from?”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-078",
      "id": "foot_078"
    }
  }, [_vm._v("b")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Matt 4:1–11//Luke 4:1–13")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td50"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("6")]), _vm._v("The Lord said, “Why did I, being God, come down? "), _c('sup', [_vm._v("7")]), _vm._v("Listen. I came down from heaven on account of you and your angels and all your assistants."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-074",
      "id": "foot_074"
    }
  }, [_vm._v("a")])]), _vm._v(" "), _c('sup', [_vm._v("8")]), _vm._v("You fell from heaven"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-075",
      "id": "foot_075"
    }
  }, [_vm._v("b")])]), _vm._v(" and you were doing nothing good, but by conquering the human you became a joke, impure demons, and you misled humans in your error.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("9")]), _vm._v("The devil said, “Go to heaven and sit on your throne. Do not make yourself manifest to my angels, for they are dreadful angels. And if you show yourself to them, Ι will be able to slaughter you like one of the humans.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("10")]), _vm._v("And the Lord said, “I came down on account of you and your angels and your accomplices. "), _c('sup', [_vm._v("11")]), _vm._v("As I kill you and release the race of humans from your error and lay them aside in their former glory, "), _c('sup', [_vm._v("12")]), _vm._v("I will make them inheritors of my everlasting kingdom. "), _c('sup', [_vm._v("13")]), _vm._v("But I will send you and all your accomplices together into the flame of gehenna and the eternal fire.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-076",
      "id": "foot_076"
    }
  }, [_vm._v("c")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Mark 9:43; Matt 18:8; 25:46; Jas 3:6")])]), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("5")]), _vm._v("The devil said, “And you, where are you from?” "), _c('sup', [_vm._v("6")]), _vm._v("Jesus said, “From the truest father and the heavenly forces.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("7")]), _vm._v("The devil said, “Are you worthy of the High One?”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-079",
      "id": "foot_079"
    }
  }, [_vm._v("c")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("8")]), _vm._v("Jesus said, “I am worthy of all heaven and earth.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-080",
      "id": "foot_080"
    }
  }, [_vm._v("d")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("9")]), _vm._v("And then the devil said, “Go to heaven and sit there on your holy throne, because the heaven is yours, but the earth is mine.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-081",
      "id": "foot_081"
    }
  }, [_vm._v("a")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("10")]), _vm._v("Jesus said, “The one who will vanquish you from the face of the earth has come.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("11")]), _vm._v("And then the devil said, “Go to heaven and sit there on your throne, because heaven is yours, but the earth is mine."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-082",
      "id": "foot_082"
    }
  }, [_vm._v("b")])]), _vm._v(" "), _c('sup', [_vm._v("12")]), _vm._v("And I will show you my angels and you will see how terrible my angels are. <They will destroy you>"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-083",
      "id": "foot_083"
    }
  }, [_vm._v("c")])]), _vm._v(" like a common human.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("13")]), _vm._v("Jesus said, “Woe to you, devil, and to your angels, because I came to earth for your angels and your accomplices.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-084",
      "id": "foot_084"
    }
  }, [_vm._v("d")])])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("On the accomplices")]), _vm._v(" "), _c('div', {
    staticClass: "inside"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td50"
  }, [_c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "chap-num"
  }, [_vm._v("2")]), _vm._v(" "), _c('sup', [_vm._v("1")]), _vm._v("The devil said, “And who are my accomplices?”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-085",
      "id": "foot_085"
    }
  }, [_vm._v("a")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("2")]), _vm._v("The Lord said, “These are your accomplices: murderers,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-086",
      "id": "foot_086"
    }
  }, [_vm._v("b")])]), _vm._v(" thieves, slanderers, darkness, fire, hailstones, upheavals, horoscopes, cursing of siblings, evil, heresy, and sectarianism.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-087",
      "id": "foot_087"
    }
  }, [_vm._v("c")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("3")]), _vm._v("The devil said, “Since these works are mine, you speak accurately,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-088",
      "id": "foot_088"
    }
  }, [_vm._v("d")])]), _vm._v(" but I am greater than you and have become superior and stronger"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-089",
      "id": "foot_089"
    }
  }, [_vm._v("e")])]), _vm._v(" than your angels.”")])]), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('span', {
    staticClass: "chap-num"
  }, [_vm._v("2")]), _vm._v(" "), _c('sup', [_vm._v("1")]), _vm._v("The devil said, “Who are my accomplices?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("2")]), _vm._v("(Jesus said), “Those who do your works.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("3")]), _vm._v("The devil said, “What are my works?”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td50"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("4")]), _vm._v("The Lord said, “You are an apparition of the world. But because of this, I was born by a woman,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-090",
      "id": "foot_090"
    }
  }, [_vm._v("f")])]), _vm._v(" so that I might correct the falling of the woman and the man,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-091",
      "id": "foot_091"
    }
  }, [_vm._v("g")])]), _vm._v(" which I formed. "), _c('sup', [_vm._v("5")]), _vm._v("Therefore, I did not leave him behind until the third heaven, until he saw the face of my father in heaven and redeemed his good things.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("6")]), _vm._v("The devil said, “You made Adam and planted paradise and cast Adam into it. But I did not make him enter into paradise for a single day.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("7")]), _vm._v("And the Lord said, “You misled Adam and chased him out of paradise. But I will not abandon him beneath your laughter.”")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Gen 3:1–5")])]), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("4")]), _vm._v("Jesus said, “Your works are strife, theft, adultery, envy, jealousy, fire, thunder, darkness, earthquake, conflicts among brothers, and war among kings.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-092",
      "id": "foot_092"
    }
  }, [_vm._v("a")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Quest. Bart.")]), _vm._v(" 4:37–38, 44")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("5")]), _vm._v("The devil said, “What you say is true, Jesus, for these are my works.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-093",
      "id": "foot_093"
    }
  }, [_vm._v("b")])]), _vm._v(" "), _c('sup', [_vm._v("6")]), _vm._v("The devil said, “I am more terrible than your angels.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-094",
      "id": "foot_094"
    }
  }, [_vm._v("c")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("7")]), _vm._v("Jesus said, “Woe to you, devil, because you are a deceiver.”")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Gal 4:4")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td50"
  }), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("8")]), _vm._v("The devil said to Jesus, “Is it not you who is the deceiver because you were born of a woman?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("9")]), _vm._v("Jesus said, “You speak truly, devil, because I was born of a woman, so that the law is fulfilled"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-095",
      "id": "foot_095"
    }
  }, [_vm._v("d")])]), _vm._v(" due to which (God) created humans in his image so that he will not abandon them forever.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-096",
      "id": "foot_096"
    }
  }, [_vm._v("e")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Ascen. Isa.")]), _vm._v(" 10:23; 11:27")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Matt 5:17")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Gen 1:27")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Gen 2:7–8")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("On repentant and unrepentant sinners")]), _vm._v(" "), _c('div', {
    staticClass: "inside"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td50"
  }, [_c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "chap-num"
  }, [_vm._v("3")]), _c('sup', [_vm._v("1")]), _vm._v("The devil said, “If a person ever sins and might renounce your glory and live by my intentions, and goes along my paths, what allotment does he have before you?”")])]), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "chap-num"
  }, [_vm._v("3")]), _vm._v(" "), _c('sup', [_vm._v("1")]), _vm._v("The devil said, “If a person begins to sin against you and begins to do my works and rejects your favor and glory, what will you do to them?”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-101",
      "id": "foot_101"
    }
  }, [_vm._v("a")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "inside"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td50"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("2")]), _vm._v("And the Lord said, “If someone ever sins and might do your deeds and live by your intentions and renounces my glory, lives for one hundred and ninety years,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-097",
      "id": "foot_097"
    }
  }, [_vm._v("a")])]), _vm._v(" and ends up repenting and follows my commandments"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-098",
      "id": "foot_098"
    }
  }, [_vm._v("b")])]), _vm._v("—"), _c('sup', [_vm._v("3")]), _vm._v("if he might befriend foreigners, guide the blind, attend to the dead in prayer and fasts, and through this might shout aloud, "), _c('sup', [_vm._v("4")]), _vm._v("and might say in his prayers, ‘God, be merciful upon me, a sinner,’ a good death comes to him and he receives forgiveness from his injustices. "), _c('sup', [_vm._v("5")]), _vm._v("But if he might not repent from the bad things that he does, especially at the age of fifty or sixty, his death comes as a sinner and I will hand him over to the angel Temeluchus,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-099",
      "id": "foot_099"
    }
  }, [_vm._v("c")])]), _vm._v(" and I will lead him away to the river of fire, where you too will be gathered with your demons, O wicked devil.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-100",
      "id": "foot_100"
    }
  }, [_vm._v("a")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Apoc. Sedr.")]), _vm._v(" 12:5")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Apoc. Pet.")]), _vm._v(" 8 [Ethiopic]; "), _c('em', [_vm._v("Apoc. Paul")]), _vm._v(" 15, 18, 34, 40")])]), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("2")]), _vm._v("Then Jesus said to him, “Listen to me, devil. If a person does your will and rejects my favor and glory, then they will live (fifty and) seven"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-102",
      "id": "foot_102"
    }
  }, [_vm._v("b")])]), _vm._v(" years from the moment they repent "), _c('sup', [_vm._v("3")]), _vm._v("by receiving strangers, having mercy on the poor, clothing the naked, comforting the afflicted, giving water to the thirsty, helping the lame to walk and burying the dead, doing deeds of mercy. "), _c('sup', [_vm._v("4")]), _vm._v("And (if) they say, ‘Lord, have mercy on me, beause I have sinned against you,’ I will send them such a blessed death. At that time, I will hand them over to the servants of archangel Michael who will accept them and lead them to paradise."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-103",
      "id": "foot_103"
    }
  }, [_vm._v("a")])]), _vm._v(" "), _c('sup', [_vm._v("5")]), _vm._v("Listen to me, devil: then if a person lives fifty and seven years and does not repent, does not have mercy on the poor, does not feed the hungry, does not give water to the thirsty, nor buries the dead, nor gives alms, nor does deeds of mercy, nor says ‘Lord, have mercy on me,’ I will send him such a hot and fiery death and a fierce angel.”")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Matt 25:31–46")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("The devil summons his demons")]), _vm._v(" "), _c('div', {
    staticClass: "inside"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td50"
  }, [_c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "chap-num"
  }, [_vm._v("4")]), _vm._v(" "), _c('sup', [_vm._v("1")]), _vm._v("Then the crafty one became furious, went away from him, and departed into his own darkness. He summoned his forty-eight thousand demons.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("2")]), _vm._v("And he said to them, “Be strong and manly! For the great Christ came down to earth and if we kill him, the kingdom will be ours forever. "), _c('sup', [_vm._v("3")]), _vm._v("Οnly let us go before him, and I behind him. We will kill him like one of the humans. From the time when he created Adam, I was not willing to worship him and so he and his father hated me.”")])]), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "chap-num"
  }, [_vm._v("4")]), _vm._v(" "), _c('sup', [_vm._v("1")]), _vm._v("The devil rose and became angry, turned away from God and went up a high mountain."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-105",
      "id": "foot_105"
    }
  }, [_vm._v("b")])]), _vm._v(" There he gathered the demons,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-106",
      "id": "foot_106"
    }
  }, [_vm._v("c")])]), _vm._v(" darkness upon darkness, thousands upon thousands."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-107",
      "id": "foot_107"
    }
  }, [_vm._v("d")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Hist. Rech.")]), _vm._v(" 21:2")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("2")]), _vm._v("And he"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-108",
      "id": "foot_108"
    }
  }, [_vm._v("e")])]), _vm._v(" said to them, “My children,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-109",
      "id": "foot_109"
    }
  }, [_vm._v("f")])]), _vm._v(" be strong and manly, because Christ the great enemy has come, so that when we vanquish him, it (will be) our honor and glory. "), _c('sup', [_vm._v("3")]), _vm._v("When his father created Adam, I did not want to kiss him, or bow to him, so his father cast me from heaven, because I did not want to have anything to do with him.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-110",
      "id": "foot_110"
    }
  }, [_vm._v("a")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("LAE")]), _vm._v(" 14–15; "), _c('em', [_vm._v("Quest. Bart.")]), _vm._v(" 4:52–54")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td50"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("4")]), _vm._v("As he was saying these things, the mass of demons and a cloud of dust were stirred up from their appearance for twenty stades. "), _c('sup', [_vm._v("5")]), _vm._v("The disciples of the Lord, after seeing the mountain, trembled. While springs sprung up and fish leapt out of the sea,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-104",
      "id": "foot_104"
    }
  }, [_vm._v("a")])]), _vm._v(" they feared greatly and said to him, “Lord, we die seeing these things.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("6")]), _vm._v("The Lord said, “Do not fear. I will slaughter him with his demons.” While they were still saying these things, the mass of demons drew nearer by thirteen stades.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("7")]), _vm._v("Philip and Thomas said, “God of all, Son of the Father, cast the devil down from heaven. Even now he will save us from him.”")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Quest. Bart.")]), _vm._v(" 4:55; "), _c('em', [_vm._v("LAE")]), _vm._v(" 16:1")])]), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("4")]), _vm._v("And he said to them,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-111",
      "id": "foot_111"
    }
  }, [_vm._v("b")])]), _vm._v(" “Brothers, go before me, I will go after you.” And they went, and dust rose from their demonic strength.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("5")]), _vm._v("The Lord’s disciples saw (this) and they said to the Lord, “Mountains shake and the sea rises even without the wind.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-112",
      "id": "foot_112"
    }
  }, [_vm._v("c")])]), _vm._v(" "), _c('sup', [_vm._v("6")]), _vm._v("And the Lord’s disciples said, “We have seen the devil’s form and heard his voice and are gripped by fear of him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("7")]), _vm._v("(The devil) came to (a distance of) ten fields.")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("The devil trapped in a cloud")]), _vm._v(" "), _c('div', {
    staticClass: "inside"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td50"
  }, [_c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "chap-num"
  }, [_vm._v("5")]), _vm._v(" "), _c('sup', [_vm._v("1")]), _vm._v("Likewise, also Peter, being extremely cowardly, ran behind Jesus."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-113",
      "id": "foot_113"
    }
  }, [_vm._v("b")])]), _vm._v(" "), _c('sup', [_vm._v("2")]), _vm._v("And the Lord said, “Do not be cowardly until you have seen the glory of God.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-114",
      "id": "foot_114"
    }
  }, [_vm._v("c")])]), _vm._v(" "), _c('sup', [_vm._v("3")]), _vm._v("Then Jesus transformed into his divine glory and commanded a cloud from heaven to suspend the devil by his feet."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-115",
      "id": "foot_115"
    }
  }, [_vm._v("d")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Acts Thom. Skin")]), _vm._v(" 8:23;")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Acts Andr. Phlm.")]), _vm._v(" 4:10;")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Acts Pet. Andr.")]), _vm._v(" 10;")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Hist. Phil.")]), _vm._v(" 4:4")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("4")]), _vm._v("His demons cried out, saying, “Where will we flee to?” "), _c('sup', [_vm._v("5")]), _vm._v("And they said to one another,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-116",
      "id": "foot_116"
    }
  }, [_vm._v("a")])]), _vm._v(" “Come, all! Let us flee into the abyss, since we will be safe.”")])]), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "chap-num"
  }, [_vm._v("5")]), _vm._v(" "), _c('sup', [_vm._v("1")]), _vm._v("Peter was overcome by demonic dread and he ran (away) from Jesus to (a distance of) four fields. "), _c('sup', [_vm._v("2")]), _vm._v("Jesus said, “Peter, why are you doing this?” Peter repented, stood behind the Lord, and watched over his shoulder."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-124",
      "id": "foot_124"
    }
  }, [_vm._v("d")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("3")]), _vm._v("Jesus turned around and said, “Who cast the devil"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-125",
      "id": "foot_125"
    }
  }, [_vm._v("e")])]), _vm._v(" from heaven?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("4")]), _vm._v("John said, “You cast the devil from heaven, did you not?”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-126",
      "id": "foot_126"
    }
  }, [_vm._v("f")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("5")]), _vm._v("Peter"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-127",
      "id": "foot_127"
    }
  }, [_vm._v("g")])]), _vm._v(" also replied, “Lord, you cast the devil from heaven. Your only father and glory and favor of which there is no like forever. Amen.”")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Quest. Bart.")]), _vm._v(" 4:55;")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("LAE")]), _vm._v(" 16:1")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td50"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("6")]), _vm._v("And the devil, the foremost one himself,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-117",
      "id": "foot_117"
    }
  }, [_vm._v("b")])]), _vm._v(" while suspended, was saying,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-118",
      "id": "foot_118"
    }
  }, [_vm._v("c")])]), _vm._v(" “Lord, let me down from these circumstances and do not kill me at this time.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-119",
      "id": "foot_119"
    }
  }, [_vm._v("d")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("7")]), _vm._v("And the Lord said, “If I let you down, you must stop making war against the race of humans, my own creation.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-120",
      "id": "foot_120"
    }
  }, [_vm._v("e")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("8")]), _vm._v("And the devil said, “My Lord, let me down and I will be able to do this, so that however many put their trust in my abominable and polluted name"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-121",
      "id": "foot_121"
    }
  }, [_vm._v("f")])]), _vm._v(" and my race might put their trust in your holy"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-122",
      "id": "foot_122"
    }
  }, [_vm._v("g")])]), _vm._v(" name.” "), _c('sup', [_vm._v("9")]), _vm._v("And the Lord commanded him to come down like lightning and to stand himself before the feet of Jesus."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-123",
      "id": "foot_123"
    }
  }, [_vm._v("h")])])])]), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("6")]), _vm._v("Then Jesus said, “I will command a cloud to come down from heaven like lightning, <take hold of>"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-128",
      "id": "foot_128"
    }
  }, [_vm._v("a")])]), _vm._v(" the devil and hang him upside down by the heel in the clouds in the skies.”")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Acts Thom. Skin")]), _vm._v(" 8:23;")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Acts Andr. Phlm.")]), _vm._v(" 4:10;")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Acts Pet. Andr.")]), _vm._v(" 10;")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Hist. Phil.")]), _vm._v(" 4:4")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("7")]), _vm._v("And he dispersed the devil’s forces like smoke. They ran into a cave and said, “What shall we poor wretches do, except run into a cave and into a hole, since they hanged our prince in the clouds in the skies.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-129",
      "id": "foot_129"
    }
  }, [_vm._v("b")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td50"
  }), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("8")]), _vm._v("At that moment, the devil saw that Christ’s word has been fulfilled. The devil (also) saw that he himself was finished and he said, “Have mercy on me, Lord, and let me go to earth.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("9")]), _vm._v("Jesus said, “Well, devil, if I have mercy on you and let you go down on earth, what good will you do to this world?”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-130",
      "id": "foot_130"
    }
  }, [_vm._v("c")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Hist. Rech.")]), _vm._v(" 21:5–6")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("10")]), _vm._v("The devil said, “Have mercy on me, Lord, and let me go to earth so that if someone believes in my shameful name, I will make it so that everyone turns to you.” And he smiled at Jesus."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-131",
      "id": "foot_131"
    }
  }, [_vm._v("d")])]), _vm._v(" "), _c('sup', [_vm._v("11")]), _vm._v("Jesus told the cloud to release (the devil) and the devil fell down to earth like lightning."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-132",
      "id": "foot_132"
    }
  }, [_vm._v("e")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Luke 10:18")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("On the Jews and John the Baptist")]), _vm._v(" "), _c('div', {
    staticClass: "inside"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td50"
  }, [_c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "chap-num"
  }, [_vm._v("6")]), _vm._v(" "), _c('sup', [_vm._v("1")]), _vm._v("Then Jesus changed into his human arrangement, just as he was born for our sake. And the devil, seeing that Jesus became like a human, took up a barb in his mouth and attempted to overpower Jesus. "), _c('sup', [_vm._v("2")]), _vm._v("And the Lord said, “Again, devil, you must suffer.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-133",
      "id": "foot_133"
    }
  }, [_vm._v("a")])])])]), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "chap-num"
  }, [_vm._v("6")]), _vm._v(" "), _c('sup', [_vm._v("1")]), _vm._v("As the devil lay (on the ground), he filled his mouth with phlegm and raised himself, wanting to outsmart Jesus."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-143",
      "id": "foot_143"
    }
  }, [_vm._v("a")])]), _vm._v(" "), _c('sup', [_vm._v("2")]), _vm._v("Jesus said to him, “I will not breathe on you, nor spit on you, devil, because my spit is holy and the air I breath out of my mouth is the Holy Spirit.”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td50"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("3")]), _vm._v("And the devil said, “I will come to Annas and Caiaphas, the high priests,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-134",
      "id": "foot_134"
    }
  }, [_vm._v("b")])]), _vm._v(" my own Jews, and I will make it so that they crucify you. I am not"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-135",
      "id": "foot_135"
    }
  }, [_vm._v("c")])]), _vm._v(" similar to the Almighty; you are his son. "), _c('sup', [_vm._v("4")]), _vm._v("But I am the terrifying Antichrist. You are the governing,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-136",
      "id": "foot_136"
    }
  }, [_vm._v("d")])]), _vm._v(" heavenly king, and I am terrestrial since when you threw me out of heaven. So, why did you come to earth and interrogate us before the appointed time?"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-137",
      "id": "foot_137"
    }
  }, [_vm._v("e")])]), _vm._v(" "), _c('sup', [_vm._v("5")]), _vm._v("Ι did not cause John the Baptist to be killed unjustly"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-138",
      "id": "foot_138"
    }
  }, [_vm._v("a")])]), _vm._v(" by Herod and his head to be marched in procession and put on orchestral display by the woman."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-139",
      "id": "foot_139"
    }
  }, [_vm._v("b")])]), _vm._v(" And if I wished to do something, every power to do so is mine.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-140",
      "id": "foot_140"
    }
  }, [_vm._v("c")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("John 18:13–14")])]), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("3")]), _vm._v("The devil said, “If I do not fight you, I will not be equal to the High One."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-144",
      "id": "foot_144"
    }
  }, [_vm._v("b")])]), _vm._v(" I will enter the heart of Caiaphas"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-145",
      "id": "foot_145"
    }
  }, [_vm._v("c")])]), _vm._v(" so that he crucifies, tortures, and kills you.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-146",
      "id": "foot_146"
    }
  }, [_vm._v("d")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("4")]), _vm._v("Jesus said, “What you say is right, devil, because I will enter the hands of sinners, since the cross is made for me; they bow to it and spit on you.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-147",
      "id": "foot_147"
    }
  }, [_vm._v("e")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("5")]), _vm._v("(The devil said,) “I made it so that John (the Baptist) was beheaded before Herod the king.”")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Mark 6:17–27//Matt 14:3–10")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Mark 6:28//Matt 14:11")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td50"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("6")]), _vm._v("And the Lord said, “John is not dead, but lives. But listen, wicked devil, you are able to reap thorny wine or to harvest barbed fruit.” "), _c('sup', [_vm._v("7")]), _vm._v("And the devil became silent, not responding at all. "), _c('sup', [_vm._v("8")]), _vm._v("And Jesus said to him, “Are you satisfied, devil? Do you have something more"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-141",
      "id": "foot_141"
    }
  }, [_vm._v("d")])]), _vm._v(" to say?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("9")]), _vm._v("And the devil said, “No, my Lord. I have nothing else to say,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-142",
      "id": "foot_142"
    }
  }, [_vm._v("e")])]), _vm._v(" but I am bound by you. You will do nothing else evil against us.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("10")]), _vm._v("And the Lord said, “In what manner would I act wickedly against myself? I will display my lordship to you and I will hand you over for destruction.”")])]), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("6")]), _vm._v("Jesus said, “John baptized me; he has not died, but he lives.”")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Mark 1:9–11 par.; John 1:29–34")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("7")]), _vm._v("The devil said, “Had I seen where you were born, I would go to that place, kill your mother, and break you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("8")]), _vm._v("The Lord said,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-148",
      "id": "foot_148"
    }
  }, [_vm._v("a")])]), _vm._v(" “Who can have wine in thorns or wheat in (a field of) thistle?”")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Matt 13:24–30")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("9")]), _vm._v("The devil did not answer anything."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-149",
      "id": "foot_149"
    }
  }, [_vm._v("b")])])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("On the devil’s destiny")]), _vm._v(" "), _c('div', {
    staticClass: "inside"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td50"
  }, [_c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "chap-num"
  }, [_vm._v("7")]), _vm._v(" "), _c('sup', [_vm._v("1")]), _vm._v("And again, Jesus transformed into his divine glory and commanded him with his power"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-150",
      "id": "foot_150"
    }
  }, [_vm._v("f")])]), _vm._v(" to be removed by thirteen stades, and he enclosed the earth with a seal and opened a gap"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-151",
      "id": "foot_151"
    }
  }, [_vm._v("g")])]), _vm._v(" about one hundred cubits long."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-152",
      "id": "foot_152"
    }
  }, [_vm._v("h")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("2")]), _vm._v("And the devil went away saying in a great voice, “O violence! Violence! Why are you doing this to me?”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-153",
      "id": "foot_153"
    }
  }, [_vm._v("a")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("3")]), _vm._v("And the Lord said,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-154",
      "id": "foot_154"
    }
  }, [_vm._v("b")])]), _vm._v(" “For seventeen"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-155",
      "id": "foot_155"
    }
  }, [_vm._v("c")])]), _vm._v(" slaves rolled over a very large stone by their"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-156",
      "id": "foot_156"
    }
  }, [_vm._v("d")])]), _vm._v(" power, so that the stone was made to roll for twenty years. Do you want to go down there?”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-157",
      "id": "foot_157"
    }
  }, [_vm._v("e")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("1 Apocr. Apoc. John")]), _vm._v(" 20:4")])]), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "chap-num"
  }, [_vm._v("7")]), _vm._v(" "), _c('sup', [_vm._v("1")]), _vm._v("Jesus commanded the earth to open three hundred sixty and three fathoms wide, and all four corners of the earth shook.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("2")]), _vm._v("The devil looked around and said, “What is this, Lord?”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-165",
      "id": "foot_165"
    }
  }, [_vm._v("c")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("3")]), _vm._v("Jesus said, “Go out, devil, and see.”")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Rev 20:2–3")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td50"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("4")]), _vm._v("The devil said, “Lord,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-158",
      "id": "foot_158"
    }
  }, [_vm._v("a")])]), _vm._v(" what will happen after then?” "), _c('sup', [_vm._v("5")]), _vm._v("And the Lord said, “From that point on, you will come from the abyss and will be born from a woman, whose name is Perdition."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-159",
      "id": "foot_159"
    }
  }, [_vm._v("b")])]), _vm._v(" You will reign for three years and many will trust you.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-160",
      "id": "foot_160"
    }
  }, [_vm._v("c")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("6")]), _vm._v("And the devil said, “Lord, and what will happen then?”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-161",
      "id": "foot_161"
    }
  }, [_vm._v("d")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("7")]), _vm._v("<The Lord said,> I will make the year like a month, the month like a week, the week like a day, the day like an hour, and the house like a speck. These days will be shortened on account of my elect.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-162",
      "id": "foot_162"
    }
  }, [_vm._v("e")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("8")]), _vm._v("The devil said, “My Lord, and what will happen then?”")])]), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("4")]), _vm._v("The devil said, “How deep is this hole?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("5")]), _vm._v("Jesus said, “If a four-year-old"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-166",
      "id": "foot_166"
    }
  }, [_vm._v("a")])]), _vm._v(" boy takes a stone that is as heavy as he can carry and throws it into the hole and it travels seven years until it reaches bottom, it will hit you, devil.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-167",
      "id": "foot_167"
    }
  }, [_vm._v("b")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("6")]), _vm._v("The devil said, “Lord, and what then?”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-168",
      "id": "foot_168"
    }
  }, [_vm._v("a")])]), _vm._v(" "), _c('sup', [_vm._v("7")]), _vm._v("Jesus said, “I will not destroy you, devil, because it is your destiny to rule for the three years before the end of time.”")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("2 Thess 2:3; John 17:12; "), _c('em', [_vm._v("Tib. Sib.")]), _vm._v(" 8:1; "), _c('em', [_vm._v("Apoc. Dan.")]), _vm._v(" 9:10")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Ps.-Hippolytus, "), _c('em', [_vm._v("Antichr.")]), _vm._v(" 6:2")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Dan 7:25; 9:27; 12:7, 11–12; Rev 11:2; 12:14; 13:5; "), _c('em', [_vm._v("1 Apocr. Apoc. John")]), _vm._v(" 8:2; "), _c('em', [_vm._v("Ascen. Isa.")]), _vm._v(" 4:12")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td50"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("9")]), _vm._v("And the Lord said, “From that point on, you will come to the place called Gouze, the land of the Egyptians. "), _c('sup', [_vm._v("10")]), _vm._v("My mother, the holy Theotokos, will come there and Elijah and Enoch and innumerable angels will kill you and you will be destroyed utterly in the eternal fire,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-163",
      "id": "foot_163"
    }
  }, [_vm._v("a")])]), _vm._v(" "), _c('sup', [_vm._v("11")]), _vm._v("because it is fitting for there to be glory to my Father and the Holy Spirit forever. Amen.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-164",
      "id": "foot_164"
    }
  }, [_vm._v("b")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Quaest. ad Ant.")]), _vm._v(" 109; "), _c('em', [_vm._v("Apoc. Dan.")]), _vm._v(" 9:8")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Rev 11:3–13; "), _c('em', [_vm._v("1 Apocr. Apoc. John")]), _vm._v(" 8:5; "), _c('em', [_vm._v("Quest. Bart.")]), _vm._v(" 1:16; "), _c('em', [_vm._v("Tib. Sib.")]), _vm._v(" 8:5; "), _c('em', [_vm._v("Apoc. El.")]), _vm._v(" 5:32–35; "), _c('em', [_vm._v("Apoc. Dan.")]), _vm._v(" 14:2–3")])]), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("8")]), _vm._v("Then the devil said, “And what then?”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-169",
      "id": "foot_169"
    }
  }, [_vm._v("b")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("9")]), _vm._v("Jesus said, “The first year, there will be much wine and rye. The second year, not a single bucket of rye will be found in the whole land.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("10")]), _vm._v("Then the devil said, “And what then?”")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("1 Apocr. Apoc. John")]), _vm._v(" 8:3; "), _c('em', [_vm._v("Tib. Sib.")]), _vm._v(" 8:2")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Ps 88:45; 89:4 LXX; Mark 13:20//Matt 24:22")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("11")]), _vm._v("Jesus said, “I will make a year into a month, a month into a week, a week into a day, a day into an hour, and an hour into a second.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-170",
      "id": "foot_170"
    }
  }, [_vm._v("c")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("1 Apocr. Apoc. John")]), _vm._v(" 8:3")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("12")]), _vm._v("The devil said, “Lord, and what then?”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-171",
      "id": "foot_171"
    }
  }, [_vm._v("d")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td50"
  }), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("13")]), _vm._v("Jesus said, “I will roll up the skies like a book and light up the earth like a big fire. And I will arrange"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-172",
      "id": "foot_172"
    }
  }, [_vm._v("e")])]), _vm._v(" it so that the sea dries and it will be like stone."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-173",
      "id": "foot_173"
    }
  }, [_vm._v("f")])]), _vm._v(" "), _c('sup', [_vm._v("14")]), _vm._v("And they"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-174",
      "id": "foot_174"
    }
  }, [_vm._v("a")])]), _vm._v(" will come to the place that is called Chizi."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-175",
      "id": "foot_175"
    }
  }, [_vm._v("b")])]), _vm._v(" "), _c('sup', [_vm._v("15")]), _vm._v("My mother who gave birth to me and John who baptized me will come here, as will Elijah and Enoch, because they did not taste death; the two of them will destroy you, devil."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-176",
      "id": "foot_176"
    }
  }, [_vm._v("c")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("16")]), _vm._v("Glory and honor and veneration to our God, the Father, the Son, and the Holy Spirit, now and forever. Amen."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-177",
      "id": "foot_177"
    }
  }, [_vm._v("d")])])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/foot.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_067",
      "id": "foot-067"
    }
  }, [_vm._v("a")]), _vm._v(". M has “Discourse of our Lord Jesus Christ regarding the dispute with the devil.” The title for V is lacking.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_068",
      "id": "foot-068"
    }
  }, [_vm._v("b")]), _vm._v(". M names Peter, Paul, and Andrew with Jesus.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_069",
      "id": "foot-069"
    }
  }, [_vm._v("c")]), _vm._v(". M lacks “holy.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_070",
      "id": "foot-070"
    }
  }, [_vm._v("d")]), _vm._v(". M has “the Lord.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_071",
      "id": "foot-071"
    }
  }, [_vm._v("e")]), _vm._v(". M lacks “entire.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_072",
      "id": "foot-072"
    }
  }, [_vm._v("f")]), _vm._v(". M adds “the devil said to him.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_073",
      "id": "foot-073"
    }
  }, [_vm._v("g")]), _vm._v(". M lacks “which you fabricated.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_074",
      "id": "foot-074"
    }
  }, [_vm._v("a")]), _vm._v(". M lacks “and all your assistants.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_075",
      "id": "foot-075"
    }
  }, [_vm._v("b")]), _vm._v(". M lacks “you fell.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_076",
      "id": "foot-076"
    }
  }, [_vm._v("c")]), _vm._v(". M lacks “As I kill you … and the eternal fire.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_077",
      "id": "foot-077"
    }
  }, [_vm._v("a")]), _vm._v(". V adds “and my wishes?”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_078",
      "id": "foot-078"
    }
  }, [_vm._v("b")]), _vm._v(". Μ adds “adulterers.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_079",
      "id": "foot-079"
    }
  }, [_vm._v("c")]), _vm._v(". The list in V contains “wheezing, sexual immoralities, false witnesses, gossip, proscription lists, sexual immorality, theft, murder, drunkenness, games, rattles, dancing, cithara music, remembrance of evil, stabbing one’s foster-sibling with a knife, separation of a married couple, jealousy toward one’s siblings and neighbors, and doing reverence but not toward God.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_080",
      "id": "foot-080"
    }
  }, [_vm._v("d")]), _vm._v(". M lacks “you speak accurately.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_081",
      "id": "foot-081"
    }
  }, [_vm._v("e")]), _vm._v(". M lacks “superior and stronger.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_082",
      "id": "foot-082"
    }
  }, [_vm._v("f")]), _vm._v(". M has “from a woman.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_083",
      "id": "foot-083"
    }
  }, [_vm._v("g")]), _vm._v(". For “correct the falling of the woman and the man ("), _c('em', [_vm._v("anthrōpon")]), _vm._v("),” M has “save the man ("), _c('em', [_vm._v("anthrōpon")]), _vm._v(").”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_084",
      "id": "foot-084"
    }
  }, [_vm._v("a")]), _vm._v(". M has “ninety.” For this sentence, V has a fragmentary line: “And again Jesus said, ‘If someone will seek and will live by your intentions and will renounce my glory until he is eighty years old and until the […].”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_085",
      "id": "foot-085"
    }
  }, [_vm._v("b")]), _vm._v(". M lacks “and follows my commandments.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_086",
      "id": "foot-086"
    }
  }, [_vm._v("c")]), _vm._v(". M has Melouch and J reads Melodox. Casey and Thomson argue that this name should be read as Temeluchus, and stems from "), _c('em', [_vm._v("tēmelougos")]), _vm._v(", “care-taking.” For this sentence, V has a fragmentary line: “[…] years and does not end up repenting, they will be handed over to the angel Temeluchus and they will carry them back into the outer darkness with the arch-evil demons and they will be punished.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_087",
      "id": "foot-087"
    }
  }, [_vm._v("a")]), _vm._v(". V adds “I will calculate it according to their error. I will seek them into the extremities and will never destroy them, because they are my creation.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_088",
      "id": "foot-088"
    }
  }, [_vm._v("a")]), _vm._v(". M lacks “of the sea.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_089",
      "id": "foot-089"
    }
  }, [_vm._v("b")]), _vm._v(". M lacks “Likewise, also Peter, being extremely cowardly, ran behind Jesus,” but includes “And Peter, being afraid of the devil … <the devil> wished to terrify Jesus” (ellipses and reconstruction provided by Casey and Thomson).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_090",
      "id": "foot-090"
    }
  }, [_vm._v("c")]), _vm._v(". M adds “it was written … and he stood at the feet of Jesus” (ellipses provided by Casey and Thomson).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_091",
      "id": "foot-091"
    }
  }, [_vm._v("d")]), _vm._v(". V lacks these two sentences and instead reads: “The devil said, ‘You are king in the heavens, but I am over this earth. You are Christ and I am the Antichrist.’ Jesus said, ‘O Satan, are you debating again?’ And our Lord Jesus Christ prayed and suspended the devil in a cloud from heaven by his feet and he covered him in smoke from the smoke of sulfur.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_092",
      "id": "foot-092"
    }
  }, [_vm._v("a")]), _vm._v(". M lacks “And they said to one another” but includes “but.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_093",
      "id": "foot-093"
    }
  }, [_vm._v("b")]), _vm._v(". M lacks “the devil, the foremost one himself” but includes “that one.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_094",
      "id": "foot-094"
    }
  }, [_vm._v("c")]), _vm._v(". M has “cried out, saying.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_095",
      "id": "foot-095"
    }
  }, [_vm._v("d")]), _vm._v(". V reads: “And the devil cried out in a great voice, saying, ‘Lord, get me out of this situation, and as many as have trusted in my abominable name, I will make them repent toward you.’ ”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_096",
      "id": "foot-096"
    }
  }, [_vm._v("e")]), _vm._v(". M lacks “my own creation.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_097",
      "id": "foot-097"
    }
  }, [_vm._v("f")]), _vm._v(". M lacks “my name.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_098",
      "id": "foot-098"
    }
  }, [_vm._v("g")]), _vm._v(". M lacks “holy.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_099",
      "id": "foot-099"
    }
  }, [_vm._v("h")]), _vm._v(". V reads: “And the Lord commanded him to be put down upon the earth and, as the devil was cast down like lightning upon the earth, hurling a great wheeze into his mouth, he rose up to overpower Jesus.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_100",
      "id": "foot-100"
    }
  }, [_vm._v("a")]), _vm._v(". Instead of this sentence, V has an expanded exchange similar to 6:1–2 in the Church Slavic text: “Jesus said to him, ‘O Satan, are you debating again? I will not spit on you or breathe upon you, for my spit is healing and is my power, while my all-holy breath comes from my mouth. Yes! My powers are great. Even if I do not make war against you, I will be king of the ages.’ The devil said, ‘On earth, you are Christ and I am the antichrist.’ And Jesus said, ‘You are a shadow.’ The devil said, ‘And you are a shadow who was born of a woman.’ Jesus said, ‘Truly I was born of a woman, and because of that I never abandon the race of humanity. I made them and never abandon them, but I will kill you.’ ”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_101",
      "id": "foot-101"
    }
  }, [_vm._v("b")]), _vm._v(". M reads “to the high priests.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_102",
      "id": "foot-102"
    }
  }, [_vm._v("c")]), _vm._v(". M lacks “not” and is emended to include “not” by Casey and Thomson.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_103",
      "id": "foot-103"
    }
  }, [_vm._v("d")]), _vm._v(". M lacks “governing.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_104",
      "id": "foot-104"
    }
  }, [_vm._v("e")]), _vm._v(". M lacks “So, why did you come to earth and interrogate us before the appointed time?”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_105",
      "id": "foot-105"
    }
  }, [_vm._v("a")]), _vm._v(". M lacks “unjustly.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_106",
      "id": "foot-106"
    }
  }, [_vm._v("b")]), _vm._v(". V contradicts the devil’s statement in M and J: “The devil said, ‘And I … by the high priest Caiaphas, as I caused John the Baptist to be beheaded by Herod the king and for his head to be given on a platter for the dancing of the little girl before Herod’ ” (ellipses provided by Casey and Thomson). Cf. Church Slavic 6:5.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_107",
      "id": "foot-107"
    }
  }, [_vm._v("c")]), _vm._v(". M lacks “And if I wished to do something, every power to do so is mine.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_108",
      "id": "foot-108"
    }
  }, [_vm._v("d")]), _vm._v(". M lacks “more.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_109",
      "id": "foot-109"
    }
  }, [_vm._v("e")]), _vm._v(". M finishes the chapter here.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_110",
      "id": "foot-110"
    }
  }, [_vm._v("f")]), _vm._v(". M lacks “with his power.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_111",
      "id": "foot-111"
    }
  }, [_vm._v("g")]), _vm._v(". M has “the earth.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_112",
      "id": "foot-112"
    }
  }, [_vm._v("h")]), _vm._v(". M adds “and he cast the devil down.” In lieu of 7:1 above, V reads: “Jesus said, ‘O Satan, are you debating again?’ And the Lord prayed from the third <heaven> and sealed the earth. The earth split down until the subterranean part of the abyss and he commanded that the devil be taken down there.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_113",
      "id": "foot-113"
    }
  }, [_vm._v("a")]), _vm._v(". M lacks “O violence! Violence! Why are you doing this to me?”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_114",
      "id": "foot-114"
    }
  }, [_vm._v("b")]), _vm._v(". M adds “ ‘Come down and you must see.’ And the devil said, ‘My Lord, how deep is it?’ ”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_115",
      "id": "foot-115"
    }
  }, [_vm._v("c")]), _vm._v(". M adds “years.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_116",
      "id": "foot-116"
    }
  }, [_vm._v("d")]), _vm._v(". M has “his.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_117",
      "id": "foot-117"
    }
  }, [_vm._v("e")]), _vm._v(". For v. 3, V reads: “Jesus said, ‘Where you are going, sixty-eight men will roll a stone by their own strength and for fifty years the stone will be falling, as a mustard seed, until it comes near to the place where you are.’ ”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_118",
      "id": "foot-118"
    }
  }, [_vm._v("a")]), _vm._v(". M has “my Lord.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_119",
      "id": "foot-119"
    }
  }, [_vm._v("b")]), _vm._v(". M lacks “from the abyss and will be born from a woman, whose name is Perdition.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_120",
      "id": "foot-120"
    }
  }, [_vm._v("c")]), _vm._v(". V reads: “Jesus said, ‘You will be there until the completion of the age, being beaten by twenty-four angels all night and day, but after the completion of the age, you will be brought out upon the earth and will go to the city of Daphne in the land of Gouze, being made similar to a pickled fish. A virgin woman by the name of Eudokia will bear you, because you ought to be born from injustice ("), _c('em', [_vm._v("Apoc. Dan.")]), _vm._v(" 9:1–13). After being born from her for three months, you will sit upon your throne on the earth and reign for three years.’ ”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_121",
      "id": "foot-121"
    }
  }, [_vm._v("d")]), _vm._v(". M lacks “what” and the explicit question format.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_122",
      "id": "foot-122"
    }
  }, [_vm._v("e")]), _vm._v(". It appears that v. 7 (“I will make … on account of my elect”) should be attributed to Jesus, but attribution is lacking from the manuscript. V reads: “And the devil said, ‘How long will I reign?’ Jesus said, ‘O Satan, do not rejoice that you will reign, but I am able to shift the years (as the book says) and will make three years into three months or three weeks, the weeks into days, the days into hours, the hours into specks.’ The devil said, ‘Lord, what will happen from that point?’ Jesus said, ‘Bread and much wine will emerge at that same year (cf. Irenaeus, "), _c('em', [_vm._v("Haer.")]), _vm._v(" 5.33.3–4; "), _c('em', [_vm._v("Apoc. Dan.")]), _vm._v(" 10:2–4) […] and during those two years there will be found to the four corners neither wine nor olives, except the morsel of bread and the half liter of olive oil of the barren woman’ ” ("), _c('em', [_vm._v("1 Apocr. Apoc. John")]), _vm._v(" 5; cf. "), _c('em', [_vm._v("Syr. Apoc. Dan.")]), _vm._v(" 18; 1 Kgs 17:12; 2 Kgs 4:2).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_123",
      "id": "foot-123"
    }
  }, [_vm._v("a")]), _vm._v(". M lacks “and you will depart into the eternal fire” but includes “abortion, evil devil.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_124",
      "id": "foot-124"
    }
  }, [_vm._v("b")]), _vm._v(". V reads: “ ‘I myself will come with Enoch and Elijah and John and with my mother the Virgin and with the holy John, the one who baptized me and of whom you said, “I caused him to be beheaded for a plaything of nobility to be given on a platter before Herod.” I will send him out for reproach and your destruction. They will convict you so that your name no longer appears in heaven nor on earth.’ […] because the great power of our Lord Jesus Christ, in whom is the glory and the power forever and ever. Amen.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_125",
      "id": "foot-125"
    }
  }, [_vm._v("a")]), _vm._v(". Lit.: “became angry with great anger.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_126",
      "id": "foot-126"
    }
  }, [_vm._v("b")]), _vm._v(". In K2–4, it is the devil who asks this question.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_127",
      "id": "foot-127"
    }
  }, [_vm._v("c")]), _vm._v(". BDHI and K2–4 have “Are you the son of the High One?” with Jesus replying “I am.” J2 LM lack the entire exchange (1:7–9).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_128",
      "id": "foot-128"
    }
  }, [_vm._v("d")]), _vm._v(". BD add “The devil said, ‘Your armies of angels cannot see you speaking in heaven and listening to you on earth. You have strong angels, why don’t you listen to them and come down to earth to us?” H adds “(Jesus said,) ‘The heavenly host could not see the face of God in them.’ ” I adds “And the devil said, ‘If you are the son of God, why have you come here?’ ” M adds “The devil said, ‘My angels appear, since your father cast me down from heaven.’ ”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_129",
      "id": "foot-129"
    }
  }, [_vm._v("a")]), _vm._v(". J1 begins with “If you are the son of the High One.” K2 and K3 add “so that my angels don’t find you and destroy you.” K4 adds “so that my angels don’t destroy you.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_130",
      "id": "foot-130"
    }
  }, [_vm._v("b")]), _vm._v(". K1 begins here.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_131",
      "id": "foot-131"
    }
  }, [_vm._v("c")]), _vm._v(". This phrase is missing from A and has been added on the basis of the readings in other manuscripts.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_132",
      "id": "foot-132"
    }
  }, [_vm._v("d")]), _vm._v(". The term this manuscript and most of the others use is "), _c('em', [_vm._v("s")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǐ")]), _c('em', [_vm._v("větnik")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǐ")]), _vm._v(", which is a variant of "), _c('em', [_vm._v("s")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǔ")]), _vm._v(" "), _c('em', [_vm._v("vět")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǐ")]), _c('em', [_vm._v("nik")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǔ")]), _vm._v(", a derivation of "), _c('em', [_vm._v("s")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǔ")]), _c('em', [_vm._v("vět")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǔ")]), _vm._v(", “council.” J2 and M use the term "), _c('em', [_vm._v("svetelnik")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǐ")]), _vm._v(" "), _c('em', [_vm._v("/ světil")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǐ")]), _c('em', [_vm._v("nik")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǐ")]), _vm._v(", respectively, which Casey and Thomson translate as “luminary.” This word derives from "), _c('em', [_vm._v("svět")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǔ")]), _vm._v(", “light” (note the spelling), and normally means “light source.” Considering the similarity of the two roots, the very much out-of-place term “luminary” can safely be considered a scribal error.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_133",
      "id": "foot-133"
    }
  }, [_vm._v("a")]), _vm._v(". The list changes in every recension, see the section “Analysis of the Church Slavic Tradition” above.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_134",
      "id": "foot-134"
    }
  }, [_vm._v("b")]), _vm._v(". M lacks 2:5–3:1 and a portion of 3:2, most likely as a result of scribal error.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_135",
      "id": "foot-135"
    }
  }, [_vm._v("c")]), _vm._v(". B has “I am greater than your angels and older than you.” D has “I am greater than your angels and stronger than you.” H and I have “I am stronger than you and my angels (are stronger) than your angels.” J1 J2 K3 and L have “I am stronger than you and more terrible than your angels.” K1 has “I am greater than your (angels) and older than everyone.” K2 and K4 have “I am stronger and more terrible than you and your angels.” M lacks the entire exchange.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_136",
      "id": "foot-136"
    }
  }, [_vm._v("d")]), _vm._v(". The manuscript has “does not end,” which is probably a scribal error: "), _c('em', [_vm._v("neskon")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǔ")]), _c('em', [_vm._v("čěet")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǐ")]), _vm._v(", “does not end,” for "), _c('em', [_vm._v("iskon")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǔ")]), _c('em', [_vm._v("čěet")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǐ")]), _vm._v(","), _c('em'), _vm._v(" “ends, is fulfilled.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_137",
      "id": "foot-137"
    }
  }, [_vm._v("e")]), _vm._v(". Most other recensions have a version of “… so that the word is fulfilled: ‘I created human beings in my image and I will not abandon them forever.’ ”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_138",
      "id": "foot-138"
    }
  }, [_vm._v("a")]), _vm._v(". BD lack this verse. I has “The devil said, ‘(Tell me) about the people, whom you are speaking of now, those you will never abandon; so if they sin against you and reject your glory and honor and do my will and works, what will you do to them?’ ” J has a formulation similar to that of I and adds “Jesus said to him, ‘Listen to me, devil: for (evil) ideas, I will condemn them to darkness; for (evil) works, I will deliver them to fire, because ideas come first and works are done after (them).’ The devil said, ‘If they act (according to) my ideas and reject your honor and glory, what will you do to them?’ ” L has “And if a person sins, doing my work and evil ideas, what happens to them?”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_139",
      "id": "foot-139"
    }
  }, [_vm._v("b")]), _vm._v(". “Fifty and” is restored on the basis of the parallel in 3:5. Different recensions give different numbers.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_140",
      "id": "foot-140"
    }
  }, [_vm._v("a")]), _vm._v(". H lacks this verse.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_141",
      "id": "foot-141"
    }
  }, [_vm._v("b")]), _vm._v(". In H, the mountain is the Mount of Olives. In M, there is no mountain.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_142",
      "id": "foot-142"
    }
  }, [_vm._v("c")]), _vm._v(". Here and in what follows, LM J1 and J2 use the term "), _c('em', [_vm._v("běs")]), _vm._v(", “evil spirit,” as opposed to "), _c('em', [_vm._v("dijavol")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǐ")]), _vm._v(", lit. “devil.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_143",
      "id": "foot-143"
    }
  }, [_vm._v("d")]), _vm._v(". For “darkness upon darkness, thousands upon thousands” (ADI and K2–4), B has “all his servants, four thousand,” H has “all his forces,” J2 has “darkness, evil spirits assembled.” K1 lacks this formulation. J1 and L have a different verse: J1 has “Having said that, Jesus went up a high mountain. Here Jesus saw great darkness which the devil had gathered, darkness upon darkness, thousands upon thousands.” L has “Our Lord Jesus Christ went up a high mountain together with his disciples. Jesus Christ saw from on high a great darkness of evil spirits which Satanael had collected, his servants, darkness upon darkness.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_144",
      "id": "foot-144"
    }
  }, [_vm._v("e")]), _vm._v(". L has “Satanael.” J1 has “Satan.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_145",
      "id": "foot-145"
    }
  }, [_vm._v("f")]), _vm._v(". K1 has “sons”; K2–4 have “brothers.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_146",
      "id": "foot-146"
    }
  }, [_vm._v("a")]), _vm._v(". H has lacks this verse. M adds before this verse “Go before me and I will go behind you. I will send you to Beelzebub, who is not afraid of great strength.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_147",
      "id": "foot-147"
    }
  }, [_vm._v("b")]), _vm._v(". J2 and K1–5 have “servants” here and in what follows.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_148",
      "id": "foot-148"
    }
  }, [_vm._v("c")]), _vm._v(". J1 J2 and L lack this verse.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_149",
      "id": "foot-149"
    }
  }, [_vm._v("d")]), _vm._v(". K1 adds “God asks, ‘Who cast the devil from heaven?’ Thomas and Philip and Bartholomew and John all said, ‘God is above all.’ A great number of angels came down from heaven with dust and angrily berated the devil.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_150",
      "id": "foot-150"
    }
  }, [_vm._v("e")]), _vm._v(". L has “Satan.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_151",
      "id": "foot-151"
    }
  }, [_vm._v("f")]), _vm._v(". Only A has this verse. J1 has “John and James said, ‘You, Lord.’ ”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_152",
      "id": "foot-152"
    }
  }, [_vm._v("g")]), _vm._v(". The manuscripts disagree on the identity of the respondent; see the section “Analysis of the Church Slavic Tradition” above.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_153",
      "id": "foot-153"
    }
  }, [_vm._v("a")]), _vm._v(". Restored on the basis of other recensions.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_154",
      "id": "foot-154"
    }
  }, [_vm._v("b")]), _vm._v(". B lacks this verse.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_155",
      "id": "foot-155"
    }
  }, [_vm._v("c")]), _vm._v(". B is damaged from here.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_156",
      "id": "foot-156"
    }
  }, [_vm._v("d")]), _vm._v(". HI J1–2 lack vv. 9–10.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_157",
      "id": "foot-157"
    }
  }, [_vm._v("e")]), _vm._v(". J2 lacks this verse.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_158",
      "id": "foot-158"
    }
  }, [_vm._v("a")]), _vm._v(". D adds “Jesus said, ‘Are you thinking of me, devil?’ The devil said, ‘You, too, spit on me and breathed on me!’ ” H adds “Jesus approached him and said to him, ‘Are you thinking the same, devil?’ ” I adds “Jesus said to him, ‘Do you hear the same, devil?’ ” J1 and L add “Jesus said, ‘Are you thinking I should spit on you?’ ” J2 and M add “Jesus said, ‘Are you thinking of grabbing me, devil?’ ”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_159",
      "id": "foot-159"
    }
  }, [_vm._v("b")]), _vm._v(". In M, Jesus says this sentence.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_160",
      "id": "foot-160"
    }
  }, [_vm._v("c")]), _vm._v(". K2–4 have “the hearts of the Jews.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_161",
      "id": "foot-161"
    }
  }, [_vm._v("d")]), _vm._v(". K1 has “If I do not fight you, I cannot oppose the High One. I will enter the hearts of the Jews so that they crucify you and kill you and I will oppose the High One.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_162",
      "id": "foot-162"
    }
  }, [_vm._v("e")]), _vm._v(". J1 lacks vv. 3–4.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_163",
      "id": "foot-163"
    }
  }, [_vm._v("a")]), _vm._v(". K1 adds here “You are lying, devil.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_164",
      "id": "foot-164"
    }
  }, [_vm._v("b")]), _vm._v(". M lacks this verse.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_165",
      "id": "foot-165"
    }
  }, [_vm._v("c")]), _vm._v(". H has “Jesus said to him, ‘See, devil, how big is the abyss in which you will reside, along with those who worship your name.’ ” I has “And Jesus said, ‘Do you see the large thing behind you?’ The devil looked around and saw behind him a great abyss. He was shocked and said, ‘What is this, Lord?’ ” M has “The devil looked around and saw the great abyss and said, ‘Lord, what is this? Do not destroy me!’ ”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_166",
      "id": "foot-166"
    }
  }, [_vm._v("a")]), _vm._v(". The text of A has “thirty-year-old,” which is clearly an error considering the fact that it uses the term "), _c('em', [_vm._v("junoša")]), _vm._v(", “boy,” and that the Cyrillic letter "), _c('em', [_vm._v("l")]), _vm._v(" (which stands for thirty) and the Cyrillic letter "), _c('em', [_vm._v("d")]), _vm._v(" (which stands for four) are easily confused. D and J1 have the same error; H has “three” and I has “four.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_167",
      "id": "foot-167"
    }
  }, [_vm._v("b")]), _vm._v(". From here, K4 has a different ending: “ ‘This is how deep the abyss is where you will reside, along with all your servants.’ The devil ran into the abyss, vanquished by the Lord. And Jesus and his disciples returned to Jerusalem to teach in the temple about the kingdom of God.” The recension then continues with homiletic material listing a number of occasions in the Bible where prayer and fasting (typically for forty days) saved someone. K2 also has a different ending from here: “ ‘This is how deep the abyss is where you are to go, together with all your servants.’ And so the devil went, defeated by the Lord. Jesus with his disciples returned to Jerusalem and taught in the temple. Do not marvel, brothers, that our Lord Jesus Christ let himself be tempted by the devil; that is why he came to the world (original: "), _c('em', [_vm._v("mir")]), _vm._v(") and for our sake allowed himself to die. You then remain in fast and prayer, so that you can join God’s elect saints for ever and ever. Amen.” K3 ends similarly: “The devil ran, humiliated and defeated by the Lord. Jesus with his disciples returned to Jerusalem and taught in the temple about the kingdom of God. Do not marvel, brothers, that our Lord Jesus Christ let himself be tempted by the devil and spoke to him, because this is why he came to the world (original: "), _c('em', [_vm._v("svet")]), _vm._v("), to rid us of him. Rather, brothers, remain in prayer and purity and love and alms, so that you will join God’s elect saints, so that after those good deeds we too defeat the devil and accept eternal life from God. May the Father, the Son, and the Holy Spirit lead us to it. Amen.” H and I add: “(This is) where you will reside, devil, here I will bind you with unbreakable bonds and put you down in the lowest (layers) of earth and you will reside here until the end of this age.” L also includes a reference to the devil being bound, this time with an unbreakable iron chain (see below).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_168",
      "id": "foot-168"
    }
  }, [_vm._v("a")]), _vm._v(". J2 and M lack vv. 3–6.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_169",
      "id": "foot-169"
    }
  }, [_vm._v("b")]), _vm._v(". I lacks vv. 7–8.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_170",
      "id": "foot-170"
    }
  }, [_vm._v("c")]), _vm._v(". Lit., “a mark, a stroke (of a pen).”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_171",
      "id": "foot-171"
    }
  }, [_vm._v("d")]), _vm._v(". M is damaged from here.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_172",
      "id": "foot-172"
    }
  }, [_vm._v("e")]), _vm._v(". Lit., “send.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_173",
      "id": "foot-173"
    }
  }, [_vm._v("f")]), _vm._v(". From here, K1 has a different ending: “And God said, ‘Go into the abyss, devil, and reside here until the judgment day, for your disbelief.’ Lord, have mercy on us and all the world. Amen.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_174",
      "id": "foot-174"
    }
  }, [_vm._v("a")]), _vm._v(". Singular, as the verbal form could refer to any gender.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_175",
      "id": "foot-175"
    }
  }, [_vm._v("b")]), _vm._v(". H and J1 lack this verse. D and J2 have “And I will come to the place that is called "), _c('em', [_vm._v("Chizi")]), _vm._v(".” I has “I will come to my place which is called "), _c('em', [_vm._v("Chižina")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_176",
      "id": "foot-176"
    }
  }, [_vm._v("c")]), _vm._v(". J1 has “Jesus said, ‘I will send Elijah and Enoch to contend with you and then your lies will come to light on the altar, as the prophet David says, ‘Then bulls will be offered on your altar’ (Ps 51:19). I will then come to the place where John baptized me and my mother gave birth to me and then I will vanquish you.’ ” The same passage is quoted in "), _c('em', [_vm._v("Apoc. Dan.")]), _vm._v(" 14:12.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_177",
      "id": "foot-177"
    }
  }, [_vm._v("d")]), _vm._v(". For vv. 13–16, L has wording that is substantially different from the majority tradition: “Jesus Christ said, ‘My heaven will devour the earth and the sea will dry up like stone; the earth will burn and people will rise from the dead. And I will condemn all tribes of the earth and you, Satan, I will condemn you and all people who do your works. Yours will be eternal torture and mine will be glory and honor and veneration for ever.’ Jesus then pushed the devil with his foot into the fiery abyss. After his resurrection, our Lord Jesus Christ went into this deepest abyss, took hold of the devil and bound him with an iron chain that cannot be sundered until the judgment day. Those who were there in the deepest hell beginning with Adam until Jesus’s resurrection, Jesus freed them all and led them out. Glory to his victory to all the world and all the Christian people; we celebrate the victory of our Lord Jesus Christ in the Holy Trinity, one Father, Son, and Holy Spirit, now and always and forever and ever. Amen.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25984f7d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/012_Chapter03.vue
// module id = 90
// module chunks = 0